<template>
    <v-container fluid>
        <AccessParkingModal v-if="typeQR === 'parking'" :qr_code="qr_code" @close="resetCamera" />
        <AccessShipmentsModal v-if="typeQR === 'shipment'" :qr_code="qr_code" @close="resetCamera" />
        <!-- Diálogo de visualización -->
        <v-dialog v-model="dialogShowDocument" max-width="900px">
            <v-card>
                <v-toolbar flat color="primary" dark>
                <v-toolbar-title>Visualizador de Archivo</v-toolbar-title>
                <v-spacer></v-spacer>

                <!-- Botón Descargar -->
                <!-- <v-btn icon @click="downloadFile" :disabled="!fileUrl">
                    <v-icon>cloud_download</v-icon>
                </v-btn> -->

                <!-- Botón Cerrar -->
                <v-btn icon @click="dialogShowDocument = false">
                    <v-icon>close</v-icon>
                </v-btn>
                </v-toolbar>

                <v-card-text>
                <!-- PDF -->
                <div v-if="isPdf" style="height: 80vh;">
                    <iframe
                    :src="fileUrl"
                    width="100%"
                    height="100%"
                    frameborder="0"
                    ></iframe>
                </div>

                <!-- Imagen -->
                <div v-else style="text-align: center;">
                    <img
                    :src="fileUrl"
                    alt="Imagen"
                    style="max-width: 100%; max-height: 80vh; border-radius: 8px;"
                    />
                </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDocumentos" scrollable max-width="600px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        Documentos Adjuntos
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogDocumentos = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout wrap class="text-xs-center">
                        <template v-for="(doc, key) in missingDocumentations">
                        <v-flex xs12 sm6 :key="`preview-${key}`" class="mb-4">
                            <v-card outlined class="pa-3">
                            <div class="font-weight-bold">{{ doc.name }}</div>
                            <div v-if="doc.file" class="grey--text text--darken-1 text-truncate" style="max-width: 100%;">
                                Archivo adjunto
                            </div>
                            <div v-else class="grey--text text--darken-1 text-truncate" style="max-width: 100%;">
                                No se adjuntó este documento
                            </div>
                            <v-btn
                                small
                                color="primary"
                                class="mt-2"
                                @click="openDialog(doc.file)"
                                :disabled="!doc.file"
                            >
                                Visualizar
                            </v-btn>
                            </v-card>
                        </v-flex>
                        </template>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
<!--        <h2 class="subheading grey&#45;&#45;text">{{$t('entradas_salidas')}}</h2>-->
        <!--    Diálogo Configurar IP   -->
        <v-dialog v-model="dialogIP" persistent width="400">
            <v-card class="justify-center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Cambiar IP</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogIP = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-text-field
                        v-model="ip"
                        outline
                        label="IP"
                        placeholder="192.168.1.45"
                    >
                    </v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="dialogIP = false, changeDirIP()"
                    >
                        {{$t('modificar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Opciones   -->
        <v-dialog v-model="dialogReasons" persistent width="400">
            <v-card class="justify-center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('select_reason')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogReasons = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-flex xs12>
                    <v-radio-group
                            v-model="reasons"
                            prepend-icon="fact_check"
                            name="reasons"
                            :mandatory="false"
                    >
                        <v-radio :label="$t('inappropriate_behavior')" :value="$t('inappropriate_behavior')"></v-radio>
                        <v-radio :label="$t('lack_equipment')" :value="$t('lack_equipment')"></v-radio>
                        <v-radio :label="$t('inconvenient_state_health')" :value="$t('inconvenient_state_health')"></v-radio>
                        <v-radio :label="$t('high_temperature')" :value="$t('high_temperature')"></v-radio>
                        <v-radio :label="$t('inconsistent_false_data')" :value="$t('inconsistent_false_data')"></v-radio>
                    </v-radio-group>
                </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            :loading="loading_reason"
                            @click="chooseReason"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Errores   -->
        <v-dialog v-model="dialog_errores"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
<!--                    <h3 class="text-xs-center">{{errores_guard}}</h3>-->
                    <div class="text-xs-center" v-html="errores_guard" />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
<!--                    <v-btn-->
<!--                            v-if="band_tolerance"-->
<!--                            color="success"-->
<!--                            x-small-->
<!--                            :loading="loading"-->
<!--                            @click="create_acceso_tolerance()"-->
<!--                    >{{$t('force_access')}}-->
<!--                    </v-btn>-->
                    <v-btn
                            v-if="band_gafete"
                            color="primary"
                            x-small
                            :loading="loading_gafete"
                            @click="download_gafete"
                    >{{$t('print_name_tag')}}
                    </v-btn>
                    <v-btn
                            v-if="survey"
                            color="primary"
                            x-small
                            @click="dialogShowSurvey = true"
                    >{{$t('answer')}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = '', activar_camara = true, band_gafete = false, bandAccessNoCode = false, bandPreregisterNoCode = false, band_tolerance = false,
                            dataAccessNoCode = {
                                    'id': 0,
                                    'id_vigilante': 0,
                                    'id_caseta': 0,
                                    'id_empresa':0 ,
                                    'id_empleado': 0,
                                    'id_area': 0,
                                    'f_acceso': '',
                                    'f_salida': '',
                                    'url_foto': '',
                                    'nombre': '',
                                    'telefono': '',
                                    'empresa': '',
                                    'notas': '',
                                    'estado': 0,
                                    'authorized': false,
                                    'pase_salida': false,
                                    'count_authorized': 2,
                                    'count_pase_salida': 2
                                  },
                            data_access_contractor = {
                                'id': 0,
                                'host': '',
                                'guest': '',
                                'url_foto': '',
                                'authorized': false,
                                'pase_salida': false,
                                'count_authorized': 2,
                                'count_pase_salida': 2,
                                'estado': -1,
                                'notas': '',
                                'empresa': '',
                                'f_acceso': '',
                                'company_logo': '',
                                'areaName': ''
                            }"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo para mostrar encusta COVID al Vigilante y asi pueda contestarla  -->
        <v-dialog v-model="dialogShowSurvey"
                  scrollable
                  persistent
                  width="800"
        >
          <v-card class="justify-center">
            <v-toolbar color="primary" dark>
              <v-icon>masks</v-icon><v-toolbar-title>{{$t('header_survey')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="dialogShowSurvey = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              {{$t('top1_survey')}}
              <br><br>
              {{$t('top2_survey')}}
              <br>
              <br>
              <v-divider></v-divider>
              <br>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <strong>{{$t('question1')}}</strong>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="row1" row>
                    <v-radio small :label="$t('Si')" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <strong>{{$t('question2')}}</strong>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="row2" row>
                    <v-radio small :label="$t('Si')" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <strong>{{$t('question3')}}</strong>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="row3" row>
                    <v-radio small :label="$t('Si')" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <strong>{{$t('question4')}}</strong>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="row4" row>
                    <v-radio small :label="$t('Si')" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <br>
              {{$t('below_survey')}}
              <br><br>
              <strong class="text-xs-centers">{{$t('msg_below_survey')}}</strong><br><br>
              <strong>{{$t('nombre')}}: </strong>{{name}}
              <br>
              <strong>{{$t('Fecha')}}: </strong>{{dd}}/{{mm}}/{{yyyy}}
              <v-divider></v-divider>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-center">
              <v-alert :value="contestado" type="error" class="black--text">
                  {{$t('msg_error_survey')}}
              </v-alert>
              <v-btn v-show="!contestado" @click="send" :loading="loading" block color="primary">{{$t('enviar')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Diálogo modal Persistente para seleccionar la Caseta -->
        <v-dialog v-model="dialog_inicio" persistent max-width="400px">
            <v-form @submit.prevent="set_caseta()">
                <v-card class="justify-center">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('selecciona_caseta')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-autocomplete
                                v-model="caseta"
                                name="caseta"
                                :items="casetas"
                                item-text="nombre"
                                item-value="id"
                                :label="$t('Casetas')"
                        ></v-autocomplete>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                type="submit"
                        >{{ $t('aceptar') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog v-model="dialog_cellphone" max-width="290">
        <v-card>
          <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
          <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialog_cellphone = false">{{$t('aceptar')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <v-dialog v-model="dialog" persistent scrollable max-width="1000px">
            <v-card v-if="entrada" :color="info_invitation.authorized ? 'blue-grey lighten-4' : 'yellow lighten-2'" class="elevation-5 center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="Object.keys(info_invitation).length > 0">
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_invitado')}}</h2>
                        <br>
                        <v-alert
                            outline
                            :value="info_invitation.meetsTolerance"
                            color="error"
                            transition="scale-transition"
                            icon="new_releases"
                        >
                          {{$t('msg_out_date_within_tolerance')}}
                        </v-alert>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.guest_Avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                                <v-btn
                                    color="primary"
                                    class="mt-2"
                                    v-if="info_invitation.documentationByInvitation.length > 0"
                                    :loading="loadingDocumentation"
                                    @click="showDocumentation()"
                                >
                                    Ver Documentos Adjuntos 
                                </v-btn>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Visitante')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestFirstName}}
                                                {{ info_invitation.guestLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('celular')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestCellPhone}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.guestNameCompany !== null">
                                        <th>
                                            <h2>
                                                {{$t('Empresa')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestNameCompany}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.secEqu.length > 0">
                                        <th>
                                            <h2>
                                                {{$t('equipo_seguridad')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h3>

                                                <div v-for="(equipo, index) in info_invitation.secEqu" v-bind:key="equipo.index">
                                                    <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>
                                                </div>
                                            </h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Asunto')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.asunto}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('multiple_accesses')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.multiple_accesses ? $t('Si') : 'No'}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('dias_validos')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2 v-if="info_invitation.diary.includes('0') === true">
                                                {{ $t('Lunes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('1') === true">
                                                {{ $t('Martes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('2') === true">
                                                {{ $t('Miercoles') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('3') === true">
                                                {{ $t('Jueves') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('4') === true">
                                                {{ $t('Viernes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('5') === true">
                                                {{ $t('Sabado') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('6') === true">
                                                {{ $t('Domingo') }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('fecha_expiracion')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.expiration}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                                <v-layout align-center justify-center row wrap class="mt-4">
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-text-field
                                                outline
                                                v-if="info_invitation.automovil"
                                                v-model="datos_coche"
                                                prepend-icon="directions_car"
                                                name="datos_coche"
                                                :label="$t('datos_coche')"
                                                :error-messages="errores.datos_coche"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                       <v-text-field
                                                outline
                                                type="number"
                                                v-if="info_invitation.health_survey"
                                                v-model="temperature"
                                                prepend-icon="thermostat"
                                                name="temperature"
                                                :label="$t('temperature')"
                                                :error-messages="errores.temperature"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-divider :inset="false"></v-divider>
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_anfitrion')}}</h2>
                        <br>
                        <v-alert
                            outline
                            :value="info_invitation.meetsTolerance"
                            color="error"
                            transition="scale-transition"
                            icon="new_releases"
                        >
                          {{$t('msg_out_date_within_tolerance')}}
                        </v-alert>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.host_avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Anfitrion')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.hostFirstName}}
                                                {{ info_invitation.hostLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('celular')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.host_celular}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-layout align-center justify-center row wrap>
                        <v-flex v-if="!info_invitation.authorized" xs12 class="text-xs-center">
                            <h3>{{$t('attemps')}} : {{info_invitation.count}}/2</h3>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn
                                    large
                                    color="error"
                                    @click="dialog = false, activar_camara = true"
                            >{{ $t('cerrar')}}
                            </v-btn>
                            <v-btn
                                    v-if="info_invitation.authorized && sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(info_invitation.id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="info_invitation.authorized && !sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="updateAccessforAccess(data_access[0].id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0 && countDown === 0"
                                    large
                                    color="primary"
                                    :loading="loading"
                                    @click="notificar_anfitrion_acceso()"
                            >
                                Notificar al anfitrión <br> autorizar acceso
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0 && countDown > 0"
                                    large
                                    color="primary"
                            >
                                Disponible en : {{countDown}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count === 0  && sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(info_invitation.id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count === 0 && !sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="updateAccessforAccess(data_access[0].id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0"
                                    large
                                    :loading="loadingCountIn"
                                    color="primary"
                                    @click="updateCountEntrada()"
                            >
                                <v-icon>refresh</v-icon>
                            </v-btn>
                            <v-btn
                                    large
                                    color="error"
                                    @click="showOptions"
                            >
                                <v-icon>block</v-icon>
                                {{$t('deny_access')}}
                            </v-btn>
                            <v-btn
                                      v-if="sala_espera"
                                      large
                                      color="primary"
                                      :loading="loading"
                                      @click="enviarSalaEspera(), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false"
                              >
                                  <v-icon>living</v-icon>
                                  {{$t('send_waiting_room')}}
                              </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
            <v-card v-if="salida" :color="data_access[0].pase_salida ? 'blue-grey lighten-4' : 'red lighten-2'" class="elevation-5 center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('form_salida')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="Object.keys(info_invitation).length > 0">
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_invitado')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.guest_Avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Visitante')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestFirstName}}
                                                {{ info_invitation.guestLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('celular')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestCellPhone}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.guestNameCompany !== null">
                                        <th>
                                            <h2>
                                                {{$t('Empresa')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestNameCompany}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.secEqu.length > 0">
                                        <th>
                                            <h2>
                                                {{$t('equipo_seguridad')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h3>
                                                <div v-for="(equipo, index) in info_invitation.secEqu" v-bind:key="equipo.index">
                                                    <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>
                                                </div>
                                            </h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Asunto')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.asunto}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('dias_validos')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2 v-if="info_invitation.diary.includes('0') === true">
                                                {{ $t('Lunes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('1') === true">
                                                {{ $t('Martes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('2') === true">
                                                {{ $t('Miercoles') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('3') === true">
                                                {{ $t('Jueves') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('4') === true">
                                                {{ $t('Viernes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('5') === true">
                                                {{ $t('Sabado') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('6') === true">
                                                {{ $t('Domingo') }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('fecha_expiracion')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.expiration}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                        <br>
                    </v-flex>
                    <v-divider :inset="false"></v-divider>
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_anfitrion')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.host_avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas" style="width:100%">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Anfitrion')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.hostFirstName}}
                                                {{ info_invitation.hostLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>{{$t('celular')}}:</h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.host_celular}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>{{$t('Area')}}:</h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-divider :inset="false"></v-divider>
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('Información de Acceso')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12>
                                <table :color="data_access[0].pase_salida ? 'success' : 'error'"  id="datas" style="width:100%">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Fecha y hora de acceso')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ data_access[0].fecha_hora_acceso}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Fecha y hora de salida')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ data_access[0].fecha_hora_salida ? data_access[0].fecha_hora_salida : "Pendiente" }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Estado')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{data_access[0].estado == '1' ? "Adentro" : "Afuera"}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Pase de salida')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ data_access[0].pase_salida ? "Firmado" : "No Firmado"}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-layout align-center justify-center row wrap>
                        <v-flex v-if="!data_access[0].pase_salida" xs12 class="text-xs-center">
                            <h3>{{$t('attemps')}} : {{data_access[0].count}}/2</h3>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn
                                    large
                                    color="error"
                                    @click="dialog = false, activar_camara = true"
                            >{{ $t('cerrar')}}
                            </v-btn>
                            <v-btn
                                    v-if="data_access[0].pase_salida"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="update_acceso(data_access[0].id), activar_camara = true"
                            >{{$t('registrar_salida')}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0 && countDownSign === 0"
                                    large
                                    color="primary"
                                    :loading="loading"
                                    @click="notificar_anfitrion_firmar()"
                            >
                                Notificar al anfitrión <br> firmar pase de salida
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0 && countDownSign > 0"
                                    large
                                    color="primary"
                            >
                                Disponible en : {{countDownSign}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count === 0"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="update_acceso(data_access[0].id), activar_camara = true"
                            >{{$t('registrar_salida')}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0"
                                    large
                                    :loading="loadingCount"
                                    color="primary"
                                    @click="updateCount()"
                            >
                                <v-icon>refresh</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogContractor" persistent scrollable max-width="1000px">
            <v-card class="elevation-5 center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogContractor = false, activar_camara = true">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="Object.keys(info_contractor).length > 0">
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_contractor')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_contractor.idFront"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Visitante')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_contractor.firstName}}
                                                {{ info_contractor.lastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr> -->
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('dias_validos')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2 v-if="info_contractor.diary.includes('0') === true">
                                                {{ $t('Lunes') }}
                                            </h2>
                                            <h2 v-if="info_contractor.diary.includes('1') === true">
                                                {{ $t('Martes') }}
                                            </h2>
                                            <h2 v-if="info_contractor.diary.includes('2') === true">
                                                {{ $t('Miercoles') }}
                                            </h2>
                                            <h2 v-if="info_contractor.diary.includes('3') === true">
                                                {{ $t('Jueves') }}
                                            </h2>
                                            <h2 v-if="info_contractor.diary.includes('4') === true">
                                                {{ $t('Viernes') }}
                                            </h2>
                                            <h2 v-if="info_contractor.diary.includes('5') === true">
                                                {{ $t('Sabado') }}
                                            </h2>
                                            <h2 v-if="info_contractor.diary.includes('6') === true">
                                                {{ $t('Domingo') }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('fecha_inicial')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_contractor.initialDate}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('fecha_expiracion')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_contractor.finalDate}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                                <v-flex xs12>
                                  <v-autocomplete
                                      autofocus
                                      v-model="id_empleado"
                                      prepend-icon="person"
                                      name="id_empleado"
                                      :item-text="example"
                                      item-value="id"
                                      :label="$t('Empleado')"
                                      :filter="customFilter"
                                      :error-messages="errores.id_empleado"
                                      :items="empleados"
                                      :no-data-text="$t('no_resultados')"
                                      clearable
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                  <v-autocomplete
                                      v-model="id_area"
                                      prepend-icon="location_city"
                                      name="id_area"
                                      item-text="nombre"
                                      item-value="id"
                                      :label="$t('Area')"
                                      :filter="customFilterArea"
                                      :error-messages="errores.id_area"
                                      :items="areas"
                                      :no-data-text="$t('no_resultados')"
                                      clearable
                                  >
                                  </v-autocomplete>
                                  <v-flex xs12>
                                    <v-text-field
                                        v-model="empresa"
                                        prepend-icon="business"
                                        name="empresa"
                                        :label="$t('Empresa')"
                                        :error-messages="errores.empresa"
                                    >
                                    </v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                        v-model="notas"
                                        prepend-icon="notes"
                                        name="notas"
                                        :label="$t('Notas')"
                                        :error-messages="errores.notas"
                                    >
                                    </v-text-field>
                                  </v-flex>
                                </v-flex>
                                <!-- <v-layout align-center justify-center row wrap class="mt-4">
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-text-field
                                                outline
                                                v-if="info_invitation.automovil"
                                                v-model="datos_coche"
                                                prepend-icon="directions_car"
                                                name="datos_coche"
                                                :label="$t('datos_coche')"
                                                :error-messages="errores.datos_coche"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                       <v-text-field
                                                outline
                                                type="number"
                                                v-if="info_invitation.health_survey"
                                                v-model="temperature"
                                                prepend-icon="thermostat"
                                                name="temperature"
                                                :label="$t('temperature')"
                                                :error-messages="errores.temperature"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout> -->
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-actions v-if="entrada" class="justify-center">
                    <v-layout align-center justify-center row wrap>
                        <v-flex v-if="!data_access_contractor.authorized" xs12 class="text-xs-center">
                            <h3>{{$t('attemps')}} : {{data_access_contractor.count_authorized}}/2</h3>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn
                                    large
                                    color="error"
                                    @click="dialogContractor = false, activar_camara = true"
                            >{{ $t('cerrar')}}
                            </v-btn>
                            <!-- <v-btn
                                    v-if="data_access_contractor.authorized && sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(data_access_contractor.id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn> -->
                            <v-btn
                                    v-if="data_access_contractor.authorized && !sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_access_contractor(data_access_contractor.id), dialogContractor = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                v-if="data_access_contractor.count_authorized === 2 && data_access_contractor.id === 0"
                                large
                                color="primary"
                                @click="createPreregisterAccessContractor()"
                                :loading="loading"
                            >{{$t('send_and_notify_host_access')}}
                            </v-btn>
                            <v-btn
                              v-if="!data_access_contractor.authorized && data_access_contractor.count_authorized !== 0 && countDownAuthorizedAccessContractor === 0 && data_access_contractor.id !== 0"
                              large
                              color="primary"
                              :loading="loading"
                              @click="notificar_anfitrion_acceso_contractor(data_access_contractor.id)"
                            >
                                Notificar al anfitrión <br> autorizar acceso
                            </v-btn>
                            <v-btn
                                    v-if="!data_access_contractor.authorized && data_access_contractor.count_authorized !== 0 && countDownAuthorizedAccessContractor > 0"
                                    large
                                    color="primary"
                            >
                                Disponible en : {{countDownAuthorizedAccessContractor}}
                            </v-btn>
                            <!-- <v-btn
                                    v-if="!data_access_contractor.authorized && data_access_contractor.count_authorized === 0  && sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(data_access_contractor.id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn> -->
                            <v-btn
                                    v-if="!data_access_contractor.authorized && data_access_contractor.count_authorized === 0 && !sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_access_contractor(data_access_contractor.id), dialogContractor = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access_contractor.authorized && data_access_contractor.count_authorized !== 0 && data_access_contractor.id !== 0"
                                    large
                                    :loading="loadingCountInAccessContractor"
                                    color="primary"
                                    @click="getRecordAccessContracorById(data_access_contractor.id)"
                            >
                                <v-icon>refresh</v-icon>
                            </v-btn>
                            <!-- <v-btn
                                    large
                                    color="error"
                                    @click="showOptions"
                            >
                                <v-icon>block</v-icon>
                                {{$t('deny_access')}}
                            </v-btn> -->
                            <v-btn
                                      v-if="sala_espera"
                                      large
                                      color="primary"
                                      :loading="loading"
                                      @click="create_access_contractor_waiting_room(info_contractor.id)"
                              >
                                  <v-icon>living</v-icon>
                                  {{$t('send_waiting_room')}}
                              </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
                <v-card-actions v-if="salidaContractor" class="justify-center">
                  <v-layout align-center justify-center row wrap>
                    <v-flex v-if="!data_access_contractor.pase_salida" xs12 class="text-xs-center">
                        <h3>{{$t('attemps')}} : {{data_access_contractor.count_pase_salida}}/2</h3>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        <v-btn
                                large
                                color="error"
                                @click="dialogContractor = false, activar_camara = true"
                        >{{ $t('cerrar')}}
                        </v-btn>
                        <v-btn
                                v-if="data_access_contractor.pase_salida"
                                large
                                color="success"
                                :loading="loading"
                                @click="update_acceso_contractor(data_access_contractor.id), activar_camara = true"
                        >{{$t('registrar_salida')}}
                        </v-btn>
                        <v-btn
                                v-if="!data_access_contractor.pase_salida && data_access_contractor.count_pase_salida !== 0 && countDownSign === 0"
                                large
                                color="primary"
                                :loading="loading"
                                @click="notificar_anfitrion_firmar_contractor()"
                        >
                            Notificar al anfitrión <br> firmar pase de salida
                        </v-btn>
                        <v-btn
                                v-if="!data_access_contractor.pase_salida && data_access_contractor.count_pase_salida !== 0 && countDownSign > 0"
                                large
                                color="primary"
                        >
                            Disponible en : {{countDownSign}}
                        </v-btn>
                        <v-btn
                                v-if="!data_access_contractor.pase_salida && data_access_contractor.count_pase_salida === 0"
                                large
                                color="success"
                                :loading="loading"
                                @click="update_acceso_contractor(data_access_contractor.id), activar_camara = true"
                        >{{$t('registrar_salida')}}
                        </v-btn>
                        <v-btn
                                v-if="!data_access_contractor.pase_salida && data_access_contractor.count_pase_salida !== 0"
                                large
                                :loading="loadingCount"
                                color="primary"
                                @click="updateCountAccessContractor()"
                        >
                            <v-icon>refresh</v-icon>
                        </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-layout calign-center justify-center fill-height>
        <v-tabs
            v-model="tabActivo"
            grow
            fixed-tabs
            dark
            centered
            icons-and-text
            color="primary"
            slider-color="primary">
          <v-tab @click="tab1()">
            <v-icon left>qr_code</v-icon>
            {{$t('qr_code')}}
          </v-tab>
          <v-tab v-if="getProfile.enable_parking === false">
            <v-icon left>event</v-icon>
            {{$t('assigned')}}
          </v-tab>
          <v-tab @click="tab2()" v-if="getProfile.enable_parking === false">
            <v-icon left>edit_calendar</v-icon>
            Manual
          </v-tab>
          <v-tabs-items touchless>
            <v-tab-item>
              <v-card width="800px" class="mx-auto elevation-7">
                <!--            <v-toolbar class="mb-1" dark color="primary" extended>-->
                <!--                <v-btn-->
                <!--                        color="blue"-->
                <!--                        dark-->
                <!--                        medium-->
                <!--                        absolute-->
                <!--                        bottom-->
                <!--                        left-->
                <!--                        fab-->
                <!--                        @click="dialogIP = !dialogIP"-->
                <!--                >-->
                <!--                    <v-icon>settings</v-icon>-->
                <!--                </v-btn>-->
                <!--                <v-toolbar-title>-->
                <!--                    {{$t('entradas_salidas')}}-->
                <!--                </v-toolbar-title>-->
                <!--            </v-toolbar>-->
                <!--            <v-toolbar class="mb-1" dark color="primary">-->
                <!--                <v-toolbar-title>-->
                <!--                    {{$t('entradas_salidas')}}-->
                <!--                </v-toolbar-title>-->
                <!--                <v-spacer></v-spacer>-->
                <!--            </v-toolbar>-->
                <v-card-text class="text-xs-center">
                  <h3>{{$t('mensaje_acercar_QR')}}</h3>
                  <v-spacer></v-spacer>
                  <v-form>
                    <v-layout class="justify-center" row wrap>
                      <v-flex xs8>
                        <qrcode-stream v-if="activar_camara" @decode="onDecode" @init="onInit" />
                        <p class="error">{{ error }}</p>
                      </v-flex>
                    </v-layout>
                    <v-layout class="justify-center">
                      <v-form
                          @submit.prevent="get_invitation_manual()">
                        <v-flex xs12>
                          <v-text-field
                              v-model="a_qr_code"
                              autofocus
                              prepend-icon="select_all"
                              name="a_qr_code"
                              :label="$t('qr_code')"
                              :placeholder="$t('msg_qr_code')"
                          >
                          </v-text-field>
                          <v-btn
                              :loading="loading"
                              color="primary"
                              large
                              type="submit">{{$t('enviar')}}
                          </v-btn>
                        </v-flex>
                      </v-form>
                    </v-layout>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card width="800" class="mx-auto elevation-7">
                <!--          <v-toolbar dark color="primary">-->
                <!--            <v-toolbar-title>-->
                <!--              {{$t('automatic_invitation')}}-->
                <!--            </v-toolbar-title>-->
                <!--          </v-toolbar>-->
                <v-card-text>
                  <v-switch
                      v-model="switch1"
                      :label="switch1 ? $t('no_registrado') : $t('registrado')"
                  ></v-switch>
                  <v-layout  row wrap>
                    <v-flex xs12 class="text-xs-center pt-3 pb-3 pl-3 pr-3">
                      <v-flex xs12>
                        <v-autocomplete
                                v-show="!switch1"
                                v-model="email2"
                                :items="items"
                                return-object
                                prepend-icon="email"
                                :loading="isLoading"
                                :search-input.sync="search2"
                                :item-text="fullNamePlusCellphone"
                                item-value="id"
                                :placeholder="$t('placeholder_invitados2')"
                                :label="$t('Visitante')"
                                :error-messages="errores.guests"
                                :no-data-text="$t('no_resultados')"
                                clearable
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                        :selected="data.selected"
                                        class="chip--select-multi"
                                >
                                  <v-avatar>
                                    <img :src="data.item.avatar">
                                  </v-avatar>
                                  {{data.item.first_name}} {{data.item.last_name}}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <v-list-tile-avatar>
                                  <img :src="data.item.avatar">
                                </v-list-tile-avatar>
                                {{data.item.first_name}} {{data.item.last_name}}
                            </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <vue-phone-number-input
                            v-show="switch1"
                            :only-countries="['MX']"
                            default-country-code="MX"
                            color="#D32F2F"
                            valid-color="#2196F3"
                            @update="onChange"
                            v-model="celular"
                            :translations="custom_cell_phone"
                        >
                        </vue-phone-number-input>
                      </v-flex>
                      <v-flex xs12>
                        <v-autocomplete
                            autofocus
                            v-model="id_empleado"
                            prepend-icon="person"
                            name="id_empleado"
                            :item-text="example"
                            item-value="id"
                            :label="$t('Empleado')"
                            :filter="customFilter"
                            :error-messages="errores.host"
                            :items="empleados"
                            :no-data-text="$t('no_resultados')"
                            clearable
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-autocomplete
                            v-model="id_area"
                            prepend-icon="location_city"
                            name="id_area"
                            item-text="nombre"
                            item-value="id"
                            :label="$t('Area')"
                            :filter="customFilterArea"
                            :error-messages="errores.areaId"
                            :items="areas"
                            :no-data-text="$t('no_resultados')"
                            clearable
                        >
                        </v-autocomplete>
                      </v-flex>
                      <v-layout row wrap>
                        <v-flex xs12 sm6>
                          <v-menu
                              v-model="modal2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-model="dateInv"
                                  :label="$t('fecha_inv')"
                                  prepend-icon="event"
                                  :error-messages="errores.dateInv"
                                  readonly
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateInv"
                                :min="get_current_date()"
                                :locale="$t('region')"
                                @input="modal2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-menu
                              ref="menu"
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="hora"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-model="hora"
                                  :label="$t('hora_inv')"
                                  prepend-icon="access_time"
                                  :error-messages="errores.timeInv"
                                  readonly
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="menu2"
                                v-model="hora"
                                format="24hr"
                                full-width
                                @click:minute="$refs.menu.save(hora)"
                            ></v-time-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12 sm6>
                          <v-textarea
                              disabled
                              v-model="subject"
                              prepend-icon="subject"
                              name="subject"
                              :placeholder="$t('placeholder_asunto')"
                              :label="$t('Asunto')"
                              :counter="150"
                              :maxlength="150"
                              :error-messages="errores.subject"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-label>{{ $t('mensaje_vehiculo') }}</v-label>
                          <v-radio-group
                              v-model="vehicle"
                              prepend-icon="directions_car"
                              name="vehicle"
                              :mandatory="false"
                              :error-messages="errores.vehicle"
                          >
                            <v-radio :label="$t('Si')" value=true></v-radio>
                            <v-radio label="No" value=false></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                      <v-alert
                          :value=alerta
                          type="warning"
                          outline
                          transition="scale-transition"
                      >
                        Fallo con el Servidor
                      </v-alert>
                    </v-flex>
                  </v-layout>
                  <div align="center">
                    <v-btn
                        large
                        color="primary"
                        @click="switch1 === true ? automatic_invitation() : automatic_invitation_by_guard()"
                        :loading="loading"
                    >{{$t('enviar')}}
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card width="800" class="mx-auto elevation-7">
                <!--            <v-toolbar dark color="primary">-->
                <!--                <v-toolbar-title>-->
                <!--                    {{$t('entrada_salida_no_code')}}-->
                <!--                </v-toolbar-title>-->
                <!--            </v-toolbar>-->
                <v-card-text>
                  <v-layout  row wrap class="text-xs-center">
                    <v-flex>
                      <p class="text-xs-center">{{$t('msg_access_no_code')}}</p>
                    </v-flex>
                  </v-layout>
                  <v-layout  row wrap class="text-xs-center">
                    <v-flex xs6>
                      <v-layout justify-center class="text-xs-center edge pt-3 pb-3 pl-3 pr-3" row wrap>
                        <v-flex xs12>
                          <h3>{{$t('select_video_device')}}</h3>
                          <select v-model="camera">
                            <option>{{$t('select_video_device')}}</option>
                            <option
                                v-for="device in devices"
                                :key="device.deviceId"
                                :value="device.deviceId">
                              {{ device.label }}
                            </option>
                          </select>
                          <v-img
                              width="100%"
                              :src="img !== '' ? img : require('../../assets/sin-foto.png')"
                          >
                            <v-layout row wrap>
                              <v-flex class="text-xs-left">
                                <v-avatar
                                    class="profile"
                                    color="grey"
                                    size="164"
                                    tile
                                >
                                  <div v-show="band" @click="onCapture()">
                                    <vue-web-cam
                                        v-if="bandTab === true"
                                        ref="webcam"
                                        :device-id="deviceId"
                                        width="100%"
                                        @started="onStarted"
                                        @stopped="onStopped"
                                        @error="onError"
                                        @cameras="onCameras"
                                        @camera-change="onCameraChange"
                                    />
                                  </div>
                                </v-avatar>
                              </v-flex>
                            </v-layout>
                          </v-img>
                        </v-flex>
                        <br>
                        <v-alert
                            :value="errores.url_foto"
                            color="error"
                            icon="warning"
                            outline
                        >
                          {{errores.url_foto}}
                        </v-alert>
                        <br>
                        {{$t('msg_captura_foto')}}
                      </v-layout>
                    </v-flex>
                    <v-flex xs6 class="text-xs-center pt-3 pb-3 pl-3 pr-3">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-autocomplete
                              autofocus
                              v-model="id_empleado"
                              prepend-icon="person"
                              name="id_empleado"
                              :item-text="example"
                              item-value="id"
                              :label="$t('Empleado')"
                              :filter="customFilter"
                              :error-messages="errores.id_empleado"
                              :items="empleados"
                              :no-data-text="$t('no_resultados')"
                              clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-autocomplete
                              v-model="id_area"
                              prepend-icon="location_city"
                              name="id_area"
                              item-text="nombre"
                              item-value="id"
                              :label="$t('Area')"
                              :filter="customFilterArea"
                              :error-messages="errores.id_area"
                              :items="areas"
                              :no-data-text="$t('no_resultados')"
                              clearable
                          >
                          </v-autocomplete>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-text-field
                              v-model="nombre"
                              prepend-icon="person_outline"
                              name="nombre"
                              :label="$t('nombre')"
                              :error-messages="errores.nombre"
                          >
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                      <!--                        <v-layout row wrap>-->
                      <!--                            <v-flex xs12>-->
                      <!--                                <v-text-field-->
                      <!--                                        v-model="telefono"-->
                      <!--                                        prepend-icon="phone_iphone"-->
                      <!--                                        name="telefono"-->
                      <!--                                        :label="$t('celular')"-->
                      <!--                                        placeholder="(000) 000 - 0000"-->
                      <!--                                        mask="phone"-->
                      <!--                                        :error-messages="errores.telefono"-->
                      <!--                                >-->
                      <!--                                </v-text-field>-->
                      <!--                            </v-flex>-->
                      <!--                        </v-layout>-->
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-text-field
                              v-model="empresa"
                              prepend-icon="business"
                              name="empresa"
                              :label="$t('Empresa')"
                              :error-messages="errores.empresa"
                          >
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-text-field
                              v-model="notas"
                              prepend-icon="notes"
                              name="notas"
                              :label="$t('Notas')"
                              :error-messages="errores.notas"
                          >
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-alert
                          :value=alerta
                          type="warning"
                          outline
                          transition="scale-transition"
                      >
                        Fallo con el Servidor
                      </v-alert>
                    </v-flex>
                  </v-layout>
                  <div align="center">
                    <v-flex
                        xs12 class="text-xs-center"
                        v-if="!dataAccessNoCode.authorized && bandAccessNoCode === true"
                    >
                      <h3>{{$t('attemps')}} : {{dataAccessNoCode.count_authorized}}/2</h3>
                    </v-flex>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-btn
                              v-if="dataAccessNoCode.count_authorized === 2 && bandPreregisterNoCode === false"
                              :disabled="img === ''"
                              large
                              color="primary"
                              @click="createPreregisterNoCodeWaitingRoom()"
                              :loading="loading"
                          >
                              <v-icon>living</v-icon>
                              {{$t('send_waiting_room')}}
                          </v-btn>
                        </div>
                      </template>
                      <span>{{img === '' ? $t('msg_must_capture_photo') : $t('send_waiting_room')}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-btn
                              v-if="dataAccessNoCode.count_authorized === 2"
                              :disabled="img === ''"
                              large
                              color="primary"
                              @click="createPreregisterNoCode()"
                              :loading="loading"
                          >{{$t('send_and_notify_host_access')}}
                          </v-btn>
                        </div>
                      </template>
                      <span>{{img === '' ? $t('msg_must_capture_photo') : $t('send_and_notify_host_access')}}</span>
                    </v-tooltip>
                    <v-btn
                        v-if="dataAccessNoCode.authorized"
                        large
                        color="success"
                        :loading="loading"
                        @click="create_access_no_code(dataAccessNoCode.id)"
                    >{{$t('acceso')}}
                    </v-btn>
                    <v-btn
                        v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized === 0"
                        large
                        color="yellow"
                        :loading="loading"
                        @click="create_access_no_code(dataAccessNoCode.id)"
                    >{{$t('acceso')}}
                    </v-btn>
                    <v-btn
                        v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0 && countDownAuthorizedAccessNoCode === 0 && bandAccessNoCode"
                        color="primary"
                        large
                        :loading="loading"
                        @click="notificar_anfitrion_acceso_sin_codigo(dataAccessNoCode.id)">
                      Notificar al anfitrión <br> autorizar acceso
                    </v-btn>
                    <v-btn
                        v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0 && countDownAuthorizedAccessNoCode > 0"
                        large
                        color="primary"
                    >
                      Disponible en : {{countDownAuthorizedAccessNoCode}}
                    </v-btn>
                    <v-btn
                        v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized != 0 && bandAccessNoCode"
                        large
                        :loading="loadingCountInAccessNoCode"
                        color="primary"
                        @click="getRecordAccessNoCodeById(dataAccessNoCode.id)"
                    >
                      <v-icon>refresh</v-icon>
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
        </v-layout>
    </v-container>
</template>

<script>

import { QrcodeStream } from 'vue-qrcode-reader'
import store from '@/store'
import { mapState, mapGetters } from 'vuex'
import jsPDF from 'jspdf'
import Vue from 'vue'
import '@/plugins/axios'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { WebCam } from "vue-web-cam"
import VeeValidate from 'vee-validate'
import AccessParkingModal from '@/components/vigilante/AccessParkingModal.vue'
import AccessShipmentsModal from '@/components/vigilante/AccessShipmentsModal.vue'

Vue.use(VeeValidate)
Vue.component('vue-phone-number-input', VuePhoneNumberInput)


export default {
  name: "access",
  components: {
    QrcodeStream,
    "vue-web-cam": WebCam,
    AccessParkingModal,
    AccessShipmentsModal
  },
  data () {
    return {
      typeQR: 'normal',
      qr_code: '',
      qr_code_aux: '',
      error: '',
      info_invitation: [],
      info_contractor: [],
      dialog: false,
      dialogContractor: false,
      valido: false,
      id_vigilante: 0,
      salida: false,
      salidaContractor: false,
      entrada: false,
      sala_espera: false,
      estado: '',
      motivo_no_firma: '',
      comentarios_VE: '',
      errores: [],
      datos_coche: '',
      equipo_por_invitacion: [],
      data_access: [],
      dialog_inicio: false,
      casetas: [],
      caseta: 0,
      activar_camara: true,
      loading_gafete: false,
      a_qr_code: '',
      dialog_errores: false,
      band_tolerance: false,
      band_current_time: false,
      errores_guard: '',
      head_color: '',
      band_gafete: false,
      dialogIP: false,
      ip: '127.0.0.1',
      loading: false,
      loadingCount: false,
      loadingCountIn: false,
      loadingCountInAccessNoCode: false,
      loadingCountInAccessContractor: false,

      id_empleado: '',
      id_area: '',
      celular:'',
      subject: 'Invitacion generada desde Caseta.',
      vehicle: 'false',
      areas: [],
      empleados: [],
      alerta: '',
      custom_cell_phone: { },
      band_cellphone: false,
      dialog_cellphone: false,
      cellphone_plus_country_code: '',
      modal2: false,
      menu2: false,
      hora: '',
      dateInv: '',

      img: '',
      camera: null,
      deviceId: null,
      devices: [],
      nombre: '',
      telefono: '',
      empresa: '',
      notas: '',
      band: false,
      dialogReasons: false,
      reasons: null,
      temperature: 0,
      loading_reason: false,
      bandTab: false,

      row1: false,
      row2: false,
      row3: false,
      row4: false,
      dd: null,
      mm: null,
      yyyy: null,
      contestado: false,
      name: '',
      dialogShowSurvey: false,
      survey: false,
      countDown: 0,
      idUserByInvitation: 0,
      // Variables para acceso sin codigo
      countDownAuthorizedAccessNoCode: 0,
      countDownAuthorizedAccessContractor: 0,
      dataAccessNoCode: {
        'id': 0,
        'id_vigilante': 0,
        'id_caseta': 0,
        'id_empresa':0 ,
        'id_empleado': 0,
        'id_area': 0,
        'f_acceso': '',
        'f_salida': '',
        'url_foto': '',
        'nombre': '',
        'telefono': '',
        'empresa': '',
        'notas': '',
        'estado': 0,
        'authorized': false,
        'pase_salida': false,
        'count_authorized': 2,
        'count_pase_salida': 2
      },
      data_access_contractor: {
        'id': 0,
        'host': '',
        'guest': '',
        'url_foto': '',
        'authorized': false,
        'pase_salida': false,
        'count_authorized': 2,
        'count_pase_salida': 2,
        'estado': -1,
        'notas': '',
        'empresa': '',
        'f_acceso': '',
        'company_logo': '',
        'areaName': ''
      },
      bandAccessNoCode: false,
      bandAccessContractor: false,
      bandPreregisterNoCode: false,
      bandPreregisterAccessContractor: false,
      email2: null,
      search2: null,
      entries: [],
      switch1: true,
      tabActivo: 0,
      countDownSign: 0,
      isLoading: false,
      dialogDocumentos: false,
      dialogShowDocument: false,
      fileUrl: '',
      isPdf: false,
      missingDocumentations: [],
      loadingDocumentation: false,
      ineFront: {
          "id": 1000,
          "name": "INE Frente",
          "file": "https://intrare-empresa-test.s3.amazonaws.com/media/Documentation/%2B528887773233/picture.jpeg"
      },
      ineBack: {
          "id": 1001,
          "name": "INE Reverso",
          "file": "https://intrare-empresa-test.s3.amazonaws.com/media/Documentation/%2B528887773233/picture.jpeg"
      },
    }
  },
  beforeUpdate() {
    this.custom_cell_phone ={
      "countrySelectorLabel": this.$t('codigo_pais'),
      "phoneNumberLabel": this.$t('celular_invitado'),
      "example": this.$t('ejemplo')
    },
        this.subject = this.$t('msg_automatic_subject')
  },
  created: function(){
    // console.log('dir URL = ', this.$route)
    // console.log('Contenido del query = ', this.$route.query)
    if( Object.keys(this.$route.query).length > 0) {
      console.log('tiene parametros', this.$route.query.switch1)
      this.switch1 = this.$route.query.switch1
    } else {
      console.log('NO tiene parametros')
    }
    this.tabActivo = parseInt(this.$route.params.tab)
    // console.log('Tab activo despues = ', this.tabActivo)
    this.getUsersCompany()
    this.get_areas()
    this.get_casetas()
    if(!this.getProfile.enable_parking && localStorage.getItem('id_caseta') === null){
      this.dialog_inicio = true
    }
    if(localStorage.getItem('dirIP') === null){
      this.ip = "127.0.0.1"
    } else {
      this.ip = localStorage.getItem('dirIP')
    }
    this.dateInv = this.get_current_date()
    this.timeNow()
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['caseta_vigilante', 'language']),
    fields () {
        if (!this.email2) return []

        return Object.keys(this.email2).map(key => {
            return {
                key,
                value: this.email2[key] || 'n/a'
            }
        })
    },
    items () {
        return this.entries.map(entry => {
            const email = entry.email.length > this.descriptionLimit
                ? entry.email.slice(0, this.descriptionLimit) + '...'
                : entry.email

            return Object.assign({}, entry, { email })
        })
    },
    device () {
      return this.devices.find(n => n.deviceId === this.deviceId)
    }
  },
  watch: {
    camera: function(id) {
      this.deviceId = id;
    },
    devices () {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices
      if (first) {
        this.camera = first.deviceId
        this.deviceId = first.deviceId
      }else {
        this.camera = tail.deviceId
        this.deviceId = tail.deviceId
      }
    },
    search2 (val) {
        // Items have already been loaded
        //if (this.items.length > 0) return

        // Items have already been requested
        //if (this.isLoading) return
        if (val !== null && val !== undefined) {
          if (val.length > 2) {
            this.isLoading = true
            // Lazily load input items
            const config = {
              method: 'get',
              url: 'https://empresa-service.intrare.app/simpleUser/filter?search=' + val,
              headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
              }
            };
            axios(config)
                .then(response => {
                  console.log(response.data)
                  if (this.entries.length > 0) {
                    for (var i = 0; i < response.data.length; i++) {
                      this.entries.push(response.data[i])
                    }
                  } else
                    this.entries = response.data
                })
                .catch(error => {
                  console.log(error)
                })
                .finally(() => (this.isLoading = false))
          }
        }
    },
    row1 (value) {
      this.contestado = value || this.row2 || this.row3 || this.row4
    },
    row2 (value) {
      this.contestado = this.row1 || value || this.row3 || this.row4
    },
    row3 (value) {
      this.contestado = this.row1 || this.row2 || value || this.row4
    },
    row4 (value) {
      this.contestado = this.row1 || this.row2 || this.row3 || value
    }
  },
  methods: {
    openDialog(fileUrl) {
        // 🔧 Ajusta esta ruta a tu estructura de archivos
        this.isPdf = fileUrl.toLowerCase().endsWith('.pdf')
        this.fileUrl = fileUrl
        this.dialogShowDocument = true
    },
    showDocumentation() {
        this.loadingDocumentation = true
        
        if (!this.info_invitation || !this.info_invitation.idUserGuest) {
            this.loadingDocumentation = false
            console.error('idUserGuest no disponible')
            return
        }
        
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/get-documents-by-user/' + this.info_invitation.idUserGuest + '/',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        axios(config)
            .then(response => {
                console.log('Documentos del usuario:', response.data)
                this.missingDocumentations = this.compareDocumentation(this.info_invitation.documentationByInvitation, response.data)
                this.loadingDocumentation = false
            })
            .catch(error => {
                this.loadingDocumentation = false
                console.error('Error fetching documents:', error)
            })
    },
    compareDocumentation(documentationsByInvitation, documentationsByUser) {
        console.log('Empieza a comparar documentaciones')
        
        if (!documentationsByInvitation || !Array.isArray(documentationsByInvitation)) {
            documentationsByInvitation = []
        }
        if (!documentationsByUser || !Array.isArray(documentationsByUser)) {
            documentationsByUser = []
        }
        
        let missingDocumentations = []
        
        for(let i = 0; i < documentationsByInvitation.length; i++) {
            const invDoc = documentationsByInvitation[i]
            if (!invDoc || !invDoc.id) continue
            
            let foundUserDoc = null
            for(let j = 0; j < documentationsByUser.length; j++) {
                const userDoc = documentationsByUser[j]
                if (!userDoc || !userDoc.idDocumentation) continue
                if(invDoc.idDocumentation === userDoc.idDocumentation.id) {
                    foundUserDoc = userDoc
                    break
                }
            }
            
            if (foundUserDoc) {
                missingDocumentations.push({
                    id: foundUserDoc.idDocumentation.id,
                    name: foundUserDoc.idDocumentation.name,
                    file: foundUserDoc.file
                })
            } else {
                missingDocumentations.push({
                    id: invDoc.id,
                    name: invDoc.name,
                    file: null
                })
            }
        }
        
        if (this.info_invitation && this.info_invitation.guest_ine_frente) {
            this.ineFront.file = this.info_invitation.guest_ine_frente
            missingDocumentations.push(this.ineFront)
        }
        if (this.info_invitation && this.info_invitation.guest_ine_atras) {
            this.ineBack.file = this.info_invitation.guest_ine_atras
            missingDocumentations.push(this.ineBack)
        }
        
        console.log('missingDocumentations = ', missingDocumentations)
        this.dialogDocumentos = true
        return missingDocumentations
    },
    fullNamePlusCellphone: item => item.email + ' ' + item.celular + ' ' + item.first_name + ' ' + item.last_name,
    getRecordAccessNoCodeById(id) {
      this.loadingCountInAccessNoCode = true
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/bitacora/' + id,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
        },
      };
      axios(config)
          .then(ok => {
            this.loadingCountInAccessNoCode = false
            this.dataAccessNoCode = ok.data[0]
            console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
            console.log(this.dataAccessNoCode)
            console.log('Id = ', this.dataAccessNoCode.id)
          })
          .catch(error => {
            this.loadingCountInAccessNoCode = false
            console.log(error)
          })
    },
    getRecordAccessContracorById(id) {
      this.loadingCountInAccessContractor = true
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/contractor_access/' + id,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
        },
      };
      axios(config)
          .then(ok => {
            this.loadingCountInAccessContractor = false
            if (ok.data.length > 0) {
              this.data_access_contractor = ok.data[0]
            }
            console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
            console.log(this.data_access_contractor)
            console.log('Id = ', this.data_access_contractor.id)
          })
          .catch(error => {
            this.loadingCountInAccessContractor = false
            console.log(error)
          })
    },
    countDownTimerAccessNoCode(id) {
      if(this.countDownAuthorizedAccessNoCode > 0) {
          setTimeout(() => {
              this.countDownAuthorizedAccessNoCode -= 1
              this.countDownTimerAccessNoCode(id)
          }, 1000)
      } else {
        const config2 = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/bitacora/' + id,
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
          },
        };
        axios(config2)
            .then(ok => {
              this.dataAccessNoCode = ok.data[0]
              console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
              console.log(this.dataAccessNoCode)
              console.log('Id = ', this.dataAccessNoCode.id)
            })
            .catch(error => {
              console.log(error)
            })
      }
    },
    countDownTimerAccessContractor(id) {
      if(this.countDownAuthorizedAccessContractor > 0) {
          setTimeout(() => {
              this.countDownAuthorizedAccessContractor -= 1
              this.countDownTimerAccessContractor(id)
          }, 1000)
      } else {
        const config2 = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/contractor_access/' + id,
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
          },
        };
        axios(config2)
            .then(ok => {
              if (ok.data.length > 0) {
                this.data_access_contractor = ok.data[0]
              }
              console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
              console.log(this.data_access_contractor)
              console.log('Id = ', this.data_access_contractor.id)
            })
            .catch(error => {
              console.log(error)
            })
      }
    },
    notifyAuthorizedAccessNoCode() {
        this.loading = true
        console.log('Avisar al Anfitrión que autorize el acceso sin código dela persona = ', this.dataAccessNoCode.id)
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/notifyAuthorizedAccessNoCode/' + this.dataAccessNoCode.id + '/',
            headers: {
                'Content-Type': 'application/json',
            }
        };
        axios(config)
            .then(response => {
                this.loading = false
                this.countDownAuthorizedAccessNoCode = 30
                this.countDownTimerAccessNoCode()
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                setTimeout(this.clear, 3000)
            })
            .catch(error => {
                this.loading = false
                console.log(error)
            })
    },
    countDownTimer() {
        if(this.countDown > 0) {
            setTimeout(() => {
                this.countDown -= 1
                this.countDownTimer()
            }, 1000)
        }
    },
    countDownSignTimer() {
        if(this.countDownSign > 0) {
            setTimeout(() => {
                this.countDownSign -= 1
                this.countDownSignTimer()
            }, 1000)
        }
    },
    create_access_no_code (id) {
        this.loading = true
        const config = {
            method: 'patch',
            url: 'https://empresa-service.intrare.app/update_access_no_code/' + id + '/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            data:{
              id_guardhouse_checkin: localStorage.getItem('id_caseta')
            }
        }
        axios(config)
            .then(response => {
                this.loading = false
                this.bandPreregisterNoCode = false
                this.errores_guard =this.$t('mensaje_alta_acceso_in')
                this.head_color = 'green display-1 text--primary'
                this.band_gafete = true
                this.dialog_errores = true
                setTimeout(this.clear, 3000)
            })
            .catch(error => {
                this.loading = false
                console.log(error.response.data)
                this.head_color = 'red display-1 text--primary'
                this.errores_guard = error.response.data.error
                this.dialog_errores = true
            })
    },
    create_access_contractor (id) {
        this.loading = true
        const config = {
            method: 'patch',
            url: 'https://empresa-service.intrare.app/update_access_contractor/' + id + '/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            data:{
              id_guardhouse_checkin: localStorage.getItem('id_caseta')
            }
        }
        axios(config)
            .then(response => {
                this.dialogContractor = false
                this.loading = false
                this.bandPreregisterAccessContractor = false
                this.errores_guard =this.$t('mensaje_alta_acceso_in')
                this.head_color = 'green display-1 text--primary'
                // this.band_gafete = true
                this.dialog_errores = true
                setTimeout(this.clear, 3000)
            })
            .catch(error => {
                this.loading = false
                console.log(error.response.data)
                this.head_color = 'red display-1 text--primary'
                this.errores_guard = error.response.data.error
                this.dialog_errores = true
            })
    },
    tab1 () {
      if(this.bandTab === true) {
        this.bandTab = false
        this.activar_camara = true
        console.log('Original')
      }
    },
    tab2 () {
      if(this.bandTab === false) {
        this.bandTab = true
        this.activar_camara = false
        console.log('Sin Codigo')
      }
    },
    get_current_date: function (){
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth()+1;
      var yyyy = today.getFullYear();

      if(dd<10)
      {
        dd='0'+dd;
      }

      if(mm<10)
      {
        mm='0'+mm;
      }
      today = yyyy + '-' + mm + '-' + dd;
      this.dd = dd
      this.mm = mm
      this.yyyy = yyyy
      return today
    },
    timeNow () {
      var d = new Date()
      var h = (d.getHours() < 10 ? '0' : '') + d.getHours()
      var m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
      this.hora = h + ':' + m
    },
    get_current_date_slash () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = mm + '/' + dd + '/' + yyyy
      return today
    },
    onChange (data) {
      console.log(data)
      this.cellphone_plus_country_code = data.e164
      this.band_cellphone = data.isValid
    },
    automatic_invitation () {
      if (this.band_cellphone === true) {
        this.loading = true
        this.errores = []
        let guests = []
        guests.push(
            {
              "email": null,
              "cellphone": this.cellphone_plus_country_code
            }
        )
        const config = {
          method: 'post',
          url: 'https://empresa-service.intrare.app/create_inv/',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken,
            'Accept-Language': this.language,
          },
          data:{
            guests: guests,
            host: this.id_empleado,
            areaId: this.id_area,
            dateInv: this.dateInv,
            timeInv: this.hora,
            subject: this.subject,
            vehicle: this.vehicle,
            notes: '',
            companyFrom: '',
            exp: this.dateInv,
            expiration: this.dateInv,
            diary: '',
            typeInv: 0
          }
        };
        axios(config)
            .then(ok => {
              this.loading = false
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_color', 'success')
              this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
              setTimeout(this.clear, 3000)
            })
            .catch(error => {
              this.loading = false
              if (error.response && error.response.status == 400
                  && typeof error.response.data == "object"
                  && error.response.data)
                this.errores = error.response.data
              else if (error.response.status == 404) {
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'error')
                this.$store.commit('snackbar_change_message', 'Token Inválido')
                setTimeout(this.clear, 3000)
              }
            })
            .finally(() => (this.loading = false))
      } else {
        this.dialog_cellphone = true
      }
    },
    automatic_invitation_by_guard () {
      console.log('dato es = ', this.email2)
      this.loading = true
      this.errores = []
      let guests = []
      if (this.email2 === undefined || this.email2 === null) {
        guests = null
      } else {
        guests.push(
            {
              "email": this.email2.email,
              "cellphone": this.email2.celular
            }
        )
      }
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/create_inv/guard',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken,
          'Accept-Language': this.language,
        },
        data:{
          guests: guests,
          host: this.id_empleado,
          areaId: this.id_area,
          dateInv: this.dateInv,
          timeInv: this.hora,
          subject: this.subject,
          vehicle: this.vehicle,
          notes: '',
          companyFrom: '',
          exp: this.dateInv,
          expiration: this.dateInv,
          diary: '',
          typeInv: 0
        }
      }
      axios(config)
          .then(ok => {
            this.loading = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_color', 'success')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if (error.response && error.response.status == 400
                && typeof error.response.data == "object"
                && error.response.data)
              this.errores = error.response.data
            else if (error.response.status == 404) {
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_color', 'error')
              this.$store.commit('snackbar_change_message', 'Token Inválido')
              setTimeout(this.clear, 3000)
            }
          })
          .finally(() => (this.loading = false))
    },
    get_areas: function(){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/empresas/areas/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      };
      axios(config)
          .then(response => {
            this.areas = response.data

            console.log(this.id_empresa)
          })
          .catch(error => {
            console.log(error)
          })

    },
    getUsersCompany: function(){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/empresas/usuarios/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      };
      axios(config)
          .then(response => {
            this.empleados = response.data
            console.log(this.empleados)
          })
          .catch(error => {
            console.log(error)
          })

    },
    customFilterArea (item, queryText) {
      const textOne = item.nombre.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    customFilter (item, queryText) {
      const textOne = item.first_name.toLowerCase()
      const textTwo = item.last_name.toLowerCase()
      const textThree = item.email.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
          || textTwo.indexOf(searchText) > -1
          || textThree.indexOf(searchText) > -1

    },
    example: item => item.first_name + ' ' + item.last_name +' - ' + item.email,
    onCapture() {
      this.img = this.$refs.webcam.capture();
    },
    onStarted(stream) {
      this.band = true
      console.log("On Started Event", stream);
    },
    onStopped(stream) {
      console.log("On Stopped Event", stream);
    },
    onStop() {
      if(this.bandTab === false) {
        this.$refs.webcam.stop()
      }
    },
    onStart() {
      if (this.bandTab === true) {
        this.$refs.webcam.start()
      }
    },
    onError(error) {
      console.log("On Error Event", error)
    },
    onCameras(cameras) {
      this.devices = cameras
      this.$refs.webcam.changeCamera(this.deviceId)
      console.log("On Cameras Event", cameras)
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId
      this.camera = deviceId
      console.log("On Camera Change Event", deviceId)
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },
    createPreregisterNoCode () {
      console.log('Datos de Antes del servidor: ')
      console.log(this.dataAccessNoCode)
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()

      bodyFormData.set('id_empleado', this.id_empleado)
      bodyFormData.set('id_area', this.id_area)
      bodyFormData.set('id_caseta', localStorage.getItem('id_caseta'))
      bodyFormData.set('nombre', this.nombre)
      bodyFormData.set('telefono', '0000000000')
      bodyFormData.set('empresa', this.empresa)
      bodyFormData.set('notas', this.notas)
      bodyFormData.set('count_authorized', '1')
      if (this.img !== '' && this.img.length > 6) {
        fileImageFront = this.dataURLtoFile(this.img, 'picture' + newID + '.png')
      }
      bodyFormData.append('url_foto', fileImageFront)
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/create_and_notify_grant_access_no_code/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': 'Token ' + store.getters.getToken,
          'Accept-Language': this.language,
        },
        data: bodyFormData
      };
      axios(config)
          .then(ok => {
            this.dataAccessNoCode = ok.data
            console.log('Datos devueltos por Servidor ala Crear un acceso sin codigo')
            console.log(this.dataAccessNoCode)
            console.log('Id = ', this.dataAccessNoCode.id)
            this.loading = false
            this.countDownAuthorizedAccessNoCode = 30
            this.countDownTimerAccessNoCode(this.dataAccessNoCode.id)
            this.bandAccessNoCode = true
            // this.$store.commit('snackbar_activate_true')
            // this.$store.commit('snackbar_change_color', 'success')
            // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_without'))
            // setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if(error.response && error.response.status == 400
                && typeof error.response.data == "object"
                && error.response.data)
              this.errores = error.response.data
            else
            if(error.response.status == 404)
            {
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_color', 'error')
              this.$store.commit('snackbar_change_message', 'Token Inválido')
              setTimeout(this.clear, 3000)
            }
          })
          .finally(() => (this.loading = false))

    },
    createPreregisterAccessContractor () {
      console.log('Datos de Antes del servidor: ')
      console.log(this.data_access_contractor)
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()

      bodyFormData.set('id_contractor', this.info_contractor.id)
      bodyFormData.set('id_empleado', this.id_empleado)
      bodyFormData.set('id_area', this.id_area)
      // bodyFormData.set('id_caseta', localStorage.getItem('id_caseta'))
      bodyFormData.set('empresa', this.empresa)
      bodyFormData.set('notas', this.notas)
      bodyFormData.set('count_authorized', '1')
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/create_and_notify_grant_access_contractor/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': 'Token ' + store.getters.getToken,
          'Accept-Language': this.language,
        },
        data: bodyFormData
      };
      axios(config)
          .then(ok => {
            this.data_access_contractor = ok.data
            this.sala_espera = false
            console.log('Datos devueltos por Servidor al Crear un acceso al Contratista')
            console.log(this.data_access_contractor)
            console.log('Id = ', this.data_access_contractor.id)
            this.loading = false
            this.countDownAuthorizedAccessContractor = 30
            this.countDownTimerAccessContractor(this.data_access_contractor.id)
            this.bandAccessContractor = true
            // this.$store.commit('snackbar_activate_true')
            // this.$store.commit('snackbar_change_color', 'success')
            // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_without'))
            // setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if(error.response && error.response.status == 400
                && typeof error.response.data == "object"
                && error.response.data)
              this.errores = error.response.data
            else
            if(error.response.status == 404)
            {
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_color', 'error')
              this.$store.commit('snackbar_change_message', 'Token Inválido')
              setTimeout(this.clear, 3000)
            }
          })
          .finally(() => (this.loading = false))
    },
    createPreregisterNoCodeWaitingRoom () {
      console.log('Datos de Antes del servidor: ')
      console.log(this.dataAccessNoCode)
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()

      bodyFormData.set('id_empleado', this.id_empleado)
      bodyFormData.set('id_area', this.id_area)
      bodyFormData.set('id_caseta', localStorage.getItem('id_caseta'))
      bodyFormData.set('nombre', this.nombre)
      bodyFormData.set('telefono', '0000000000')
      bodyFormData.set('empresa', this.empresa)
      bodyFormData.set('notas', this.notas)
      bodyFormData.set('count_authorized', '2')
      if (this.img !== '' && this.img.length > 6) {
        fileImageFront = this.dataURLtoFile(this.img, 'picture' + newID + '.png')
      }
      bodyFormData.append('url_foto', fileImageFront)
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/create/waiting_room_access_no_code/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': 'Token ' + store.getters.getToken,
          'Accept-Language': this.language,
        },
        data: bodyFormData
      };
      axios(config)
          .then(ok => {
            this.dataAccessNoCode = ok.data
            console.log('Datos devueltos por Servidor ala Crear un acceso sin codigo')
            console.log(this.dataAccessNoCode)
            console.log('Id = ', this.dataAccessNoCode.id)
            this.loading = false
            this.bandPreregisterNoCode = true
            this.bandAccessNoCode = true
            this.clear()
            this.errores_guard = 'Enviado a la Sala de Espera Correctamente'
            this.head_color = 'green display-1 text--primary'
            this.band_gafete = true
            this.dialog_errores = true
          })
          .catch(error => {
            this.loading = false
            if(error.response && error.response.status == 400
                && typeof error.response.data == "object"
                && error.response.data)
              this.errores = error.response.data
            else
            if(error.response.status == 404)
            {
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_color', 'error')
              this.$store.commit('snackbar_change_message', 'Token Inválido')
              setTimeout(this.clear, 3000)
            }
          })
          .finally(() => (this.loading = false))
    },
    changeDirIP () {
      localStorage.setItem('dirIP', this.ip)
    },
    get_casetas: function(){
      this.$store.dispatch('security/FETCH_MY_CASETAS', store.getters.getToken)
          .then(response => {
            // Manejar múltiples formatos de respuesta
            if (response && response.casetas && Array.isArray(response.casetas)) {
              this.casetas = response.casetas
            } else if (Array.isArray(response)) {
              this.casetas = response
            } else if (response && response.data && Array.isArray(response.data)) {
              this.casetas = response.data
            }
            if (this.getProfile.enable_parking && localStorage.getItem('id_caseta') === null) {
              const casetasActivas = this.casetas.filter(c => c.activa)
              if (casetasActivas.length === 1) {
                const casetaId = casetasActivas[0].id
                localStorage.setItem('id_caseta', casetaId)
                this.caseta = casetaId
                this.dialog_inicio = false
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_change_message', 'Caseta seleccionada correctamente')
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
    },
    set_caseta: function(){
      if(this.caseta > 0){
        localStorage.setItem('id_caseta', this.caseta)
        this.dialog_inicio = false
      }
    },
    onDecode (result) {
      this.qr_code = result
      this.get_invitation()
    },
    resetCamera() {
      this.typeQR = 'normal'
      this.activar_camara = true
      this.qr_code = ''
      this.a_qr_code = ''
    },
    get_invitation: function(){
      if (this.qr_code !== '') {
        if (this.qr_code.startsWith('prk_') || this.qr_code.startsWith('prk-')) {
          this.typeQR = 'parking'
          this.activar_camara = false
        } else if (this.qr_code.startsWith('spmt_')) {
          this.typeQR = 'shipment'
          this.activar_camara = false
        } else if (this.qr_code.length === 28) {
          const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/get_contractor/guard/' + this.qr_code + '/',
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          };
          axios(config)
              .then(response => {
                this.loading = false
                this.info_contractor = response.data
                this.valido = true
                console.log("Valido")
                // this.dialogContractor = true
                this.is_access_contractor_in_out_both()
              })
              .catch(error => {
                this.loading = false
                console.log(error.request.status)
                switch (error.request.status) {
                  case 404:
                    this.valido = false
                    console.log("No Valido")
                    this.clear_without_activate_camera()
                    this.errores_guard =this.$t('mensaje_qr_no_valido')
                    this.head_color = 'red display-1 text--primary justify-center'
                    this.dialog_errores = true
                  break;
                  case 401:
                    this.valido = false
                    this.clear_without_activate_camera()
                    this.errores_guard = error.response.data.error
                    this.head_color = 'red display-1 text--primary justify-center'
                    this.dialog_errores = true
                  break;
                }
              })
        } else {
          const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/get_inv/gaurd/' + this.qr_code + '/',
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          };
          axios(config)
              .then(response => {
                this.info_invitation = response.data
                this.valido = true
                console.log("Valido")
                this.is_access_in_out_both()
              })
              .catch(error => {
                console.log(error.request.status)
                switch (error.request.status) {
                  case 404:
                    this.valido = false
                    console.log("No Valido")
                    this.clear_without_activate_camera()
                    this.errores_guard =this.$t('mensaje_qr_no_valido')
                    this.head_color = 'red display-1 text--primary justify-center'
                    this.dialog_errores = true
                  break;
                  case 401:
                    this.valido = false
                    this.clear_without_activate_camera()
                    this.errores_guard =this.$t('mensaje_qr_no_empresa')
                    this.head_color = 'red display-1 text--primary justify-center'
                    this.dialog_errores = true
                  break;
                  case 423:
                    this.valido = false
                    this.clear_without_activate_camera()
                    this.errores_guard =this.$t('mensaje_qr_no_confirmado')
                    this.head_color = 'red display-1 text--primary justify-center'
                    this.dialog_errores = true
                  break;
                  case 406:
                    this.valido = false
                    this.clear_without_activate_camera()
                    this.errores_guard =this.$t('msg_canceled_invitation')
                    this.head_color = 'red display-1 text--primary justify-center'
                    this.dialog_errores = true
                  break;
                  case 409:
                    this.valido = false
                    this.clear_without_activate_camera2()
                    console.log(JSON.parse(error.request.response).status)
                    if (JSON.parse(error.request.response).status === 0) {
                      this.errores_guard =
                          `
                              <h4>${this.$t('msg_survey00')}</h4>
                              <br><br>
                              <h5>${this.$t('msg_survey')}</h5>
                          `
                    }
                    if (JSON.parse(error.request.response).status === 1) {
                      this.errores_guard =
                          `
                              <h4>${this.$t('msg_survey01')}</h4>
                          `
                          this.name = JSON.parse(error.request.response).name
                          this.survey = true
                          this.idUserByInvitation = JSON.parse(error.request.response).idUserByInvitation
                    }
                    this.head_color = 'primary display-1 white--text justify-center'
                    this.dialog_errores = true
                  break;
                  case 403:
                    this.valido = false
                    this.clear_without_activate_camera()
                    let mensaje = JSON.parse(error.request.response).motivo
                    console.log(JSON.parse(error.request.response).tipo)
                    if (JSON.parse(error.request.response).tipo === 1) {
                      this.errores_guard = `<h3 class="text-xs-center"> ${this.$t('mensaje_qr_vetado')} </h3><br><h4>${this.$t('reason2')} ${mensaje}</h4><br><br><h5>${this.$t('msg_veto00')}</h5>`
                    }
                    else {
                      this.errores_guard = `<h3 class="text-xs-center"> ${this.$t('mensaje_qr_vetado')} </h3><br><h4>${this.$t('reason2')} ${mensaje}</h4><br><br><h5>${this.$t('msg_veto00')}</h5>`
                    }
                    this.head_color = 'red display-1 text--primary justify-center'
                    this.dialog_errores = true
                  break;
                }
              })
          }
      }
    },
    get_invitation_manual: function(){
      if (this.a_qr_code !== '') {
        if (this.a_qr_code.startsWith('prk_') || this.a_qr_code.startsWith('prk-')) {
          this.typeQR = 'parking'
          this.activar_camara = false
          this.qr_code = this.a_qr_code
          return
        } else if (this.a_qr_code.startsWith('spmt_')) {
          this.typeQR = 'shipment'
          this.activar_camara = false
          this.qr_code = this.a_qr_code
          return
        }
      }
      this.loading = true
      if (this.a_qr_code.length === 28) {
        const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/get_contractor/guard/' + this.a_qr_code + '/',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        };
        axios(config)
            .then(response => {
              this.loading = false
              this.info_contractor = response.data
              this.valido = true
              console.log("Valido")
              // this.dialogContractor = true
              this.is_access_contractor_in_out_both()
            })
            .catch(error => {
              this.loading = false
              console.log(error.request.status)
              switch (error.request.status) {
                case 404:
                  this.valido = false
                  console.log("No Valido")
                  this.clear_without_activate_camera()
                  this.errores_guard =this.$t('mensaje_qr_no_valido')
                  this.head_color = 'red display-1 text--primary justify-center'
                  this.dialog_errores = true
                break;
                case 401:
                  this.valido = false
                  this.clear_without_activate_camera()
                  this.errores_guard = error.response.data.error
                  this.head_color = 'red display-1 text--primary justify-center'
                  this.dialog_errores = true
                break;
              }
            })
      } else {
        const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/get_inv/gaurd/' + this.a_qr_code + '/',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        };
        axios(config)
            .then(response => {
              this.loading = false
              this.info_invitation = response.data
              this.valido = true
              console.log("Valido")
              this.is_access_in_out_both()
            })
            .catch(error => {
              this.loading = false
              console.log(error.request.status)
              switch (error.request.status) {
                case 404:
                  this.valido = false
                  console.log("No Valido")
                  this.clear_without_activate_camera()
                  this.errores_guard =this.$t('mensaje_qr_no_valido')
                  this.head_color = 'red display-1 text--primary justify-center'
                  this.dialog_errores = true
                break;
                case 401:
                  this.valido = false
                  this.clear_without_activate_camera()
                  this.errores_guard =this.$t('mensaje_qr_no_empresa')
                  this.head_color = 'red display-1 text--primary justify-center'
                  this.dialog_errores = true
                break;
                case 423:
                  this.valido = false
                  this.clear_without_activate_camera()
                  this.errores_guard =this.$t('mensaje_qr_no_confirmado')
                  this.head_color = 'red display-1 text--primary justify-center'
                  this.dialog_errores = true
                break;
                case 406:
                  this.valido = false
                  this.clear_without_activate_camera()
                  this.errores_guard =this.$t('msg_canceled_invitation')
                  this.head_color = 'red display-1 text--primary justify-center'
                  this.dialog_errores = true
                break;
                case 409:
                  this.valido = false
                  this.clear_without_activate_camera2()
                  console.log(JSON.parse(error.request.response).status)
                  if (JSON.parse(error.request.response).status === 0) {
                    this.errores_guard =
                        `
                            <h4>${this.$t('msg_survey00')}</h4>
                            <br><br>
                            <h5>${this.$t('msg_survey')}</h5>
                        `
                  }
                  if (JSON.parse(error.request.response).status === 1) {
                    this.errores_guard =
                        `
                            <h4>${this.$t('msg_survey01')}</h4>
                        `
                        this.name = JSON.parse(error.request.response).name
                        this.survey = true
                        this.idUserByInvitation = JSON.parse(error.request.response).idUserByInvitation
                  }
                  this.head_color = 'primary display-1 white--text justify-center'
                  this.dialog_errores = true
                break;
                case 403:
                  this.valido = false
                  this.clear_without_activate_camera()
                  let mensaje = JSON.parse(error.request.response).motivo
                  console.log(JSON.parse(error.request.response).tipo)
                  if (JSON.parse(error.request.response).tipo === 1) {
                    this.errores_guard = `<h3 class="text-xs-center"> ${this.$t('mensaje_qr_vetado')} </h3><br><h4>${this.$t('reason2')} ${mensaje}</h4><br><br><h5>${this.$t('msg_veto00')}</h5>`
                  }
                  else {
                    this.errores_guard = `<h3 class="text-xs-center"> ${this.$t('mensaje_qr_vetado')} </h3><br><h4>${this.$t('reason2')} ${mensaje}</h4><br><br><h5>${this.$t('msg_veto00')}</h5>`
                  }
                  this.head_color = 'red display-1 text--primary justify-center'
                  this.dialog_errores = true
                break;
              }
            })
      }
    },
    qr_is_valid: function(info_invitation){
      console.log(Object.keys(info_invitation).length)
      if (Object.keys(info_invitation).length > 0) {
        this.valido = true
        console.log("Valido")
        this.is_access_in_out_both()
      }
      else{
        this.valido = false
        console.log("NO Valido")
        //     this.$store.commit('snackbar_activate_true')
        //     this.$store.commit('snackbar_change_color', 'error')
        //     this.$store.commit('snackbar_change_message', this.$t('mensaje_qr_no_valido'))
        //     setTimeout(this.clear, 3000)
        this.clear_without_activate_camera()
        this.errores_guard =this.$t('mensaje_qr_no_valido')
        this.head_color = 'red display-1 text--primary justify-center'
        this.dialog_errores = true
      }
    },
    is_access_contractor_in_out_both: function(){
      if(this.a_qr_code.length > 10)
        this.qr_code = this.a_qr_code
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/contractor_access/search/' + this.qr_code + '/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      };
      axios(config)
          .then(response => {
            console.log(response.data)
            if (response.data.length > 0) {
              this.data_access_contractor = response.data[0]
            }
            if (response.data.length === 0) {
              this.entrada = true
              this.sala_espera = true
              this.salidaContractor = false
              this.dialogContractor = true
              this.activar_camara = false
              this.data_access_contractor = {
                'id': 0,
                'host': '',
                'guest': '',
                'url_foto': '',
                'authorized': false,
                'pase_salida': false,
                'count_authorized': 2,
                'count_pase_salida': 2,
                'estado': -1,
                'notas': '',
                'empresa': '',
                'f_acceso': '',
                'company_logo': '',
                'areaName': ''
              },
              this.id_empleado = ''
              this.id_area = ''
              this.notas = ''
              this.empresa = ''
              this.errores = []
              console.log('ENTRADA CONTRATISTA NINGUN REGISTRO DE ACCESO')
            } else {
              if (response.data[0].estado === 1) {
                this.id_area = response.data[0].id_area
                this.id_empleado = response.data[0].id_empleado
                this.empresa = response.data[0].empresa
                this.notas = response.data[0].notas
                this.entrada = false
                this.sala_espera = false
                this.salidaContractor = true
                this.dialogContractor = true
                this.activar_camara = false
                console.log('SALIDA CONTRATISTA', response.data[0])
              } else
              if (response.data[0].estado === 5) {
                this.id_area = response.data[0].id_area
                this.id_empleado = response.data[0].id_empleado
                this.empresa = response.data[0].empresa
                this.notas = response.data[0].notas
                this.entrada = true
                this.sala_espera = false
                this.salidaContractor = false
                this.dialogContractor = true
                this.activar_camara = false
                this.errores = []
                console.log('ENTRADA CONTRATISTA DESDE SALA DE ESPERA', response.data[0])
              } else {
                if (response.data[0].estado === 2 || response.data[0].estado === 3) {
                  this.entrada = true
                  this.sala_espera = true
                  this.salidaContractor = false
                  this.dialogContractor = true
                  this.activar_camara = false
                  this.data_access_contractor = {
                    'id': 0,
                    'host': '',
                    'guest': '',
                    'url_foto': '',
                    'authorized': false,
                    'pase_salida': false,
                    'count_authorized': 2,
                    'count_pase_salida': 2,
                    'estado': -1,
                    'notas': '',
                    'empresa': '',
                    'f_acceso': '',
                    'company_logo': '',
                    'areaName': ''
                  },
                  console.log('ENTRADA RECURRENTE')
                } else {
                  if(response.data[0].estado === 0) {
                    this.id_area = response.data[0].id_area
                    this.id_empleado = response.data[0].id_empleado
                    this.empresa = response.data[0].empresa
                    this.notas = response.data[0].notas
                    this.entrada = true
                    this.sala_espera = false
                    this.salidaContractor = false
                    this.dialogContractor = true
                    this.activar_camara = false
                    console.log('ENTRADA CONTRATISTA')
                  }
                }
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
    },
    is_access_in_out_both: function(){
      if(this.a_qr_code.length > 10)
        this.qr_code = this.a_qr_code
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      };
      axios(config)
          .then(response => {
            console.log(response.data)
            this.data_access = response.data
            if (this.info_invitation.typeInv !== 2) { // Tipo de Invitación Normal
              if (response.data.length > 0 && response.data[0].fecha_hora_acceso != null && response.data[0].fecha_hora_salida != null){
                // alert('Ya se completó el acceso con la invitación Correspondiente.')
                if (this.info_invitation.multiple_accesses === false) {
                  console.log('COMPLETO')
                  this.clear_without_activate_camera()
                  this.head_color = 'orange display-1 text--primary justify-center'
                  this.errores_guard =this.$t('mensaje_acceso_completo')
                  this.dialog_errores = true
                } else {
                  this.entrada = true
                  this.sala_espera = true
                  this.salida = false
                  this.temperature = 0
                  this.datos_coche = ''
                  this.dialog = true
                  this.activar_camara = false
                  console.log('ENTRADA MULTIPLE')
                }
              }
              else{
                if(response.data.length > 0 ){
                  if (response.data[0].estado === 2) {
                    this.clear_without_activate_camera()
                    this.head_color = 'error display-1 text--primary justify-center'
                    this.errores_guard = this.$t('msg_invitation_registered_denied')  + response.data[0].comentarios_VE
                    this.dialog_errores = true
                    console.log('NEGADO')
                  } else
                    if (response.data[0].estado === 5) {
                      this.entrada = true
                      this.sala_espera = false
                      this.salida = false
                      this.dialog = true
                      this.activar_camara = false
                      console.log('ENTRADA DESDE SALA DE ESPERA')
                    } else {
                      this.entrada = false
                      this.sala_espera = false
                      this.salida = true
                      this.dialog = true
                      this.activar_camara = false
                      console.log('SALIDA')
                    }
                }
                else{
                  this.entrada = true
                  this.sala_espera = true
                  this.salida = false
                  this.temperature = 0
                  this.datos_coche = ''
                  this.dialog = true
                  this.activar_camara = false
                  console.log('ENTRADA')
                }
              }
            } else { // Invitación Recurrente
              if (response.data.length === 0) {
                this.entrada = true
                this.sala_espera = true
                this.salida = false
                this.temperature = 0
                this.datos_coche = ''
                this.dialog = true
                this.activar_camara = false
                console.log('ENTRADA RECURRENTE')
              } else {
                if (response.data[0].estado === 1) {
                  this.entrada = false
                  this.sala_espera = false
                  this.salida = true
                  this.dialog = true
                  this.activar_camara = false
                  console.log('SALIDA RECURRENTE', response.data[0])
                } else
                if (response.data[0].estado === 5) {
                  this.entrada = true
                  this.sala_espera = false
                  this.salida = false
                  this.dialog = true
                  this.activar_camara = false
                  console.log('ENTRADA RECURRENTE DESDE SALA DE ESPERA', response.data[0])
                } else {
                  if (response.data[0].estado !== 2) {
                    var fechaLocal = new Date(this.get_current_date_slash())
                    const readableDate = response.data[0].fecha_hora_acceso.substring(3, 6) + response.data[0].fecha_hora_acceso.substring(0, 2) + response.data[0].fecha_hora_acceso.substring(5, 10)
                    var fechaAccesoEntrada = new Date(readableDate)
                    if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                      this.entrada = true
                      this.sala_espera = true
                      this.salida = false
                      this.temperature = 0
                      this.datos_coche = ''
                      this.dialog = true
                      this.activar_camara = false
                      console.log('ENTRADA RECURRENTE')
                    } else {
                      if (this.info_invitation.multiple_accesses === false) {
                        console.log('COMPLETO RECURRENTE')
                        this.clear_without_activate_camera()
                        this.head_color = 'orange display-1 text--primary justify-center'
                        this.errores_guard = this.$t('mensaje_acceso_completo')
                        this.dialog_errores = true
                      } else {
                        this.entrada = true
                        this.sala_espera = true
                        this.salida = false
                        this.temperature = 0
                        this.datos_coche = ''
                        this.dialog = true
                        this.activar_camara = false
                        console.log('ENTRADA RECURRENTE MULTIPLE')
                      }
                    }
                  } else {
                    var fechaLocal3 = new Date(this.get_current_date_slash())
                    const readableDate = response.data[0].fecha_hora_acceso.substring(3, 6) + response.data[0].fecha_hora_acceso.substring(0, 2) + response.data[0].fecha_hora_acceso.substring(5, 10)
                    var fechaAccesoEntrada3 = new Date(readableDate)
                    if (fechaAccesoEntrada3.getTime() !== fechaLocal3.getTime()) {
                      this.entrada = true
                      this.sala_espera = true
                      this.salida = false
                      this.temperature = 0
                      this.datos_coche = ''
                      this.dialog = true
                      this.activar_camara = false
                      console.log('ENTRADA RECURRENTE')
                    } else {
                      this.clear_without_activate_camera()
                      this.head_color = 'error display-1 text--primary justify-center'
                      this.errores_guard = this.$t('msg_invitation_registered_denied') + response.data[0].comentarios_VE
                      this.dialog_errores = true
                      console.log('NEGADO')
                    }
                  }
                }
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
    },
    create_acceso: function(id_invitacion){
      this.qr_code_aux = this.qr_code
      this.loading = true
      console.log(this.qr_code)
      var qrCode = this.qr_code
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/empresas/access/create',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_invitacion: id_invitacion,
          qr_code: this.qr_code,
          datos_coche: this.datos_coche,
          id_guardhouse_checkin: localStorage.getItem('id_caseta'),
          temperature: parseFloat(this.temperature, 10)
        }
      }
      axios(config)
          .then(response => {
            this.loading = false
            this.sendDataWebServer(qrCode)
            // this.$store.commit('snackbar_activate_true')
            // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
            // this.dialog = false
            // setTimeout(this.clear, 3000);
            // console.log(this.info_invitation)
            this.clear_without_activate_camera()
            this.errores_guard =this.$t('mensaje_alta_acceso_in')
            this.head_color = 'green display-1 text--primary justify-center'
            this.band_gafete = true
            this.dialog_errores = true
          })
          .catch(error => {
            this.loading = false
            console.log(error.response.data)
            this.clear_without_activate_camera()
            this.head_color = 'red display-1 text--primary justify-center'
            console.log('Esta dentro de la tolerancia')
            console.log(this.info_invitation.meetsTolerance)
            console.log('Esta dentro de la tolerancia')
            if (error.response.data.error === '!ACCESO NEGADO¡.Esta invitacion esta fuera de fecha.') {
              this.band_tolerance = this.info_invitation.meetsTolerance
            }
            this.errores_guard = error.response.data.error
            this.dialog_errores = true
          })
    },
    create_acceso_tolerance () {
      this.band_tolerance = false
      this.dialog_errores = false
      this.loading = true
      console.log(this.qr_code)
      var qrCode = this.qr_code
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/empresas/access/tolerance/create',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_invitacion: this.info_invitation.id,
          qr_code: this.qr_code_aux,
          datos_coche: this.datos_coche,
          id_guardhouse_checkin: localStorage.getItem('id_caseta'),
          temperature: parseFloat(this.temperature, 10)
        }
      }
      axios(config)
          .then(response => {
            this.loading = false
            this.sendDataWebServer(qrCode)
            // this.$store.commit('snackbar_activate_true')
            // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
            // this.dialog = false
            // setTimeout(this.clear, 3000);
            // console.log(this.info_invitation)
            this.clear_without_activate_camera()
            this.errores_guard =this.$t('mensaje_alta_acceso_in')
            this.head_color = 'green display-1 text--primary justify-center'
            this.band_gafete = true
            this.band_current_time = true
            this.dialog_errores = true
          })
          .catch(error => {
            this.loading = false
            console.log(error.response.data)
            this.clear_without_activate_camera()
            this.head_color = 'red display-1 text--primary justify-center'
            this.errores_guard = error.response.data.error
            this.dialog_errores = true
          })
    },
    create_access_contractor_waiting_room: function(id_contractor){
      this.errores = []
      this.qr_code_aux = this.qr_code
      this.loading = true
      console.log(this.qr_code)
      var qrCode = this.qr_code
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/create/waiting_room_access_contractor/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_contractor: id_contractor,
          id_empleado: this.id_empleado,
          id_area: this.id_area,
          empresa: this.empresa,
          notas: this.notas
        }
      }
      axios(config)
          .then(response => {
            this.loading = false
            // this.$store.commit('snackbar_activate_true')
            // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
            // this.dialog = false
            // setTimeout(this.clear, 3000);
            // console.log(this.info_invitation)
            this.dialogContractor = false
            this.clear_without_activate_camera()
            this.errores_guard =this.$t('mensaje_alta_acceso_in')
            this.head_color = 'green display-1 text--primary justify-center'
            // this.band_gafete = true
            this.dialog_errores = true
          })
          .catch(error => {
            this.loading = false
            if(error.response && error.response.status == 400
                && typeof error.response.data == "object"
                && error.response.data)
              this.errores = error.response.data
            else
            if(error.response.status == 404)
            {
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_color', 'error')
              this.$store.commit('snackbar_change_message', 'Token Inválido')
              setTimeout(this.clear, 3000)
            }
          })
          .finally(() => (this.loading = false))
    },
    sendDataWebServer (qrCode) {
      const config = {
        method: 'post',
        url: 'http://' + localStorage.getItem('dirIP') + '/set_data',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          qr_code: qrCode,
          area: this.info_invitation.areaName
        }
      }
      axios(config)
          .then(response => {
            console.log('Datos enviados al Web Server Correctamente.')
            console.log(response)
          })
          .catch(error => {
            console.log('Error del Web Server.')
            console.log(error.response.data)
          })
    },
    enviarSalaEspera () {
        this.loading = true
        console.log(this.qr_code)
        const config = {
            method: 'post',
            url: 'https://empresa-service.intrare.app/empresas/access/create/waiting_room',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            data: {
                qr_code: this.qr_code,
                estado: 5,
                comentarios_VE: this.comentarios_VE
            }
        }
        axios(config)
            .then(response => {
                this.loading = false
                // this.$store.commit('snackbar_activate_true')
                // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
                // this.dialog = false
                // setTimeout(this.clear, 3000);
                // console.log(this.info_invitation)
                this.clear_without_activate_camera()
                this.errores_guard = 'Enviado a la Sala de Espera Correctamente'
                this.head_color = 'green display-1 text--primary'
                this.band_gafete = true
                this.dialog_errores = true
            })
            .catch(error => {
                this.loading = false
                console.log(error.response.data)
                this.clear_without_activate_camera()
                this.head_color = 'red display-1 text--primary'
                this.errores_guard = error.response.data.error
                this.dialog_errores = true
            })
    },
    update_acceso (pk){
      this.loading = true
      console.log(this.qr_code)
      const config = {
        method: 'put',
        url: 'https://empresa-service.intrare.app/empresas/access/update/forExit/' + pk + '/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          estado: 0,
          motivo_no_firma: this.motivo_no_firma,
          comentarios_VE: this.comentarios_VE,
          id_guardhouse_checkout: localStorage.getItem('id_caseta')
        }
      }
      axios(config)
          .then(response => {
            this.loading = false
            this.clear_without_activate_camera()
            this.head_color = 'green display-1 text--primary justify-center'
            this.errores_guard =this.$t('mensaje_alta_acceso_out')
            this.dialog_errores = true
            // this.$store.commit('snackbar_activate_true')
            // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_out'))
            // setTimeout(this.clear, 3000);
          })
          .catch(error => {
            this.loading = false
            if(error.response.status == 400
                && typeof error.response.data == "object"
                && error.response.data)
              this.errores = error.response.data
          })

    },
    update_acceso_contractor (pk){
      this.loading = true
      console.log(this.qr_code)
      const config = {
        method: 'patch',
        url: 'https://empresa-service.intrare.app/check_out_access_contractor/' + pk + '/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_guardhouse_checkout: localStorage.getItem('id_caseta')
        }
      }
      axios(config)
          .then(response => {
            this.loading = false
            this.clear_without_activate_camera()
            this.head_color = 'green display-1 text--primary justify-center'
            this.errores_guard =this.$t('mensaje_alta_acceso_out')
            this.dialog_errores = true
            // this.$store.commit('snackbar_activate_true')
            // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_out'))
            // setTimeout(this.clear, 3000);
          })
          .catch(error => {
            this.loading = false
            if(error.response.status == 400
                && typeof error.response.data == "object"
                && error.response.data)
              this.errores = error.response.data
          })

    },
    updateCount () {
      this.loadingCount = true
      const config2 = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config2)
          .then(response2 => {
            if (this.info_invitation.typeInv !== 2)
              this.data_access = response2.data
            else
            if (response2.data.length > 1) {
              this.data_access = response2.data
              console.log('Datos Accesos Count = ', response2.data[0])
            }
            else
              this.data_access = response2.data
            this.loadingCount = false
          })
          .catch(error => {
            this.loadingCount = false
            console.log(error)
          })
    },
    updateCountAccessContractor () {
      this.loadingCount = true
      const config2 = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/contractor_access/search/' + this.qr_code + '/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config2)
          .then(response2 => {
            console.log(response2.data)
            if (response2.data.length > 0) {
              this.data_access_contractor = response2.data[0]
            }
            this.loadingCount = false
          })
          .catch(error => {
            this.loadingCount = false
            console.log(error)
          })
    },
    updateAccessforAccess (pk){
        this.loading = true
        console.log(this.qr_code)
        const config = {
            method: 'put',
            url: 'https://empresa-service.intrare.app/empresas/access/update/forAccess/' + pk + '/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            data: {
                motivo_no_firma: this.motivo_no_firma,
                comentarios_VE: this.comentarios_VE,
                id_guardhouse_checkin: localStorage.getItem('id_caseta')
            }
        }
        axios(config)
            .then(response => {
                this.loading = false
                this.clear_without_activate_camera()
                this.head_color = 'green display-1 text--primary'
                this.errores_guard =this.$t('mensaje_alta_acceso_in')
                this.band_gafete = true
                this.dialog_errores = true
            })
            .catch(error => {
                this.loading = false
                if(error.response.status == 400
                    && typeof error.response.data == "object"
                    && error.response.data)
                    this.errores = error.response.data
            })

    },
    updateCountEntrada () {
      this.loadingCountIn = true
      const config2 = {
        method: 'get',
        url:  'https://empresa-service.intrare.app/get_inv/gaurd/' + this.qr_code + '/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config2)
          .then(response2 => {
            if (this.info_invitation.typeInv !== 2)
              this.info_invitation = response2.data
            else
            if (response2.data.length > 1) {
              this.info_invitation = response2.data
              console.log('Datos Invitacion Count = ', response2.data[0])
            }
            else
              this.info_invitation = response2.data
            this.loadingCountIn = false
          })
          .catch(error => {
            this.loadingCountIn = false
            console.log(error)
          })
    },
    notificar_anfitrion_firmar(){
      this.loading = true
      console.log('Avisar al Anfitrión que firme pase de Salida = ', this.data_access[0].id)
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/notifySignExitPass/' + this.data_access[0].id + '/',
        headers: {
          'Content-Type': 'application/json',
        }
      };
      axios(config)
          .then(response => {
            this.loading = false
            this.countDownSign = 30
            this.countDownSignTimer()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
            const config2 = {
              method: 'get',
              url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
              headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
              }
            }
            axios(config2)
                .then(response2 => {
                  console.log(response2.data)
                  if (this.info_invitation.typeInv !== 2)
                    this.data_access = response2.data
                  else
                  if (response2.data.length > 1) {
                    console.log('Datos de acceso despues de notificar al Antitrion = ,', response2.data[0])
                    this.data_access = response2.data
                  }
                  else
                    this.data_access = response2.data
                })
                .catch(error => {
                  console.log(error)
                })
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
    },
    notificar_anfitrion_firmar_contractor(){
      this.loading = true
      console.log('Avisar al Anfitrión que firme pase de Salida del Contratista = ', this.data_access_contractor.id)
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/notifySignExitPassAccessContractor/' + this.data_access_contractor.id + '/',
        headers: {
          'Content-Type': 'application/json',
        }
      };
      axios(config)
          .then(response => {
            this.loading = false
            this.countDownSign = 30
            this.countDownSignTimer()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
            const config2 = {
              method: 'get',
              url: 'https://empresa-service.intrare.app/contractor_access/search/' + this.qr_code + '/',
              headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
              }
            }
            axios(config2)
                .then(response2 => {
                  console.log(response2.data)
                  if (response2.data.length > 0) {
                    this.data_access_contractor = response2.data[0]
                  }
                })
                .catch(error => {
                  console.log(error)
                })
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
    },
    notificar_anfitrion_acceso(){
      this.loading = true
      console.log('Avisar al Anfitrión que autorize el acceso de su invitado= ', this.info_invitation.id)
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/notifyAuthorizedAccess/' + this.info_invitation.id + '/',
        headers: {
          'Content-Type': 'application/json',
        }
      };
      axios(config)
          .then(response => {
            this.loading = false
            this.countDown = 30
            this.countDownTimer()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
            const config2 = {
              method: 'get',
              url: 'https://empresa-service.intrare.app/get_inv/gaurd/' + this.qr_code + '/',
              headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
              }
            }
            axios(config2)
                .then(response2 => {
                  console.log(response2.data)
                  if (this.info_invitation.typeInv !== 2)
                    this.info_invitation = response2.data
                  else
                  if (response2.data.length > 1) {
                    console.log('Datos de acceso despues de notificar al Antitrion = ,', response2.data[0])
                    this.info_invitation = response2.data
                  }
                  else
                    this.info_invitation = response2.data
                })
                .catch(error => {
                  console.log(error)
                })
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
    },
    notificar_anfitrion_acceso_sin_codigo(id){
        this.loading = true
        console.log('Avisar al Anfitrión que autorize el acceso sin codigo dela persona = ', id)
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/notifyAuthorizedAccessNoCode/' + id + '/',
            headers: {
                'Content-Type': 'application/json',
            }
        };
        axios(config)
            .then(response => {
                this.loading = false
                this.countDownAuthorizedAccessNoCode = 30
                this.countDownTimerAccessNoCode(id)
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                setTimeout(this.clear3, 3000)
            })
            .catch(error => {
                this.loading = false
                console.log(error)
            })
    },
    notificar_anfitrion_acceso_contractor(id){
        this.loading = true
        console.log('Avisar al Anfitrión que autorize el acceso al contratista = ', id)
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/notifyAuthorizedAccessContractor/' + id + '/',
            headers: {
                'Content-Type': 'application/json',
            }
        };
        axios(config)
            .then(response => {
                this.loading = false
                this.countDownAuthorizedAccessContractor = 30
                this.countDownTimerAccessContractor(id)
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                setTimeout(this.clear3, 3000)
            })
            .catch(error => {
                this.loading = false
                console.log(error)
            })
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    },
    clean_fields(){
      this.id_empleado = ''
      this.id_area = ''
      this.celular = ''
      this.timeNow()

      this.img = ''
      this.nombre = ''
      this.telefono = ''
      this.empresa = ''
      this.notas = ''
    },
    clear: function () {
      this.alerta = false
      this.errores = []
      this.$validator.reset()
      this.dialog = false
      this.qr_code = ''
      this.a_qr_code = ''
      this.entrada = false
      this.salida = false
      this.email2 = null
      this.activar_camara = true
      this.sala_espera = false
      this.$store.commit('snackbar_activate_false')
      this.$store.commit('snackbar_change_color', 'success')
      this.clean_fields()
    },
    clear2: function () {
      this.alerta = false
      this.errores = []
      this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
      this.$store.commit('snackbar_change_color', 'success')
      this.clean_fields()
    },
    clear3 () {
      this.$store.commit('snackbar_activate_false')
      this.$store.commit('snackbar_change_color', 'success')
    },
    clear_without_activate_camera: function () {
      this.dialog = false
      this.dialogContractor = false
      this.activar_camara = false
      this.qr_code = ''
      this.a_qr_code = ''
      this.entrada = false
      this.salida = false
      this.sala_espera = false
    },
    clear_without_activate_camera2: function () {
      this.dialog = false
      this.activar_camara = false
      this.entrada = false
      this.salida = false
      this.sala_espera = false
    },
    xOffset: function(pdf, text){
      return ((pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2) / 72.0)
    },
    getImgFromUrl(logo_url, callback) {
      var img = new Image();
      img.src = logo_url;
      img.onload = function () {
        callback(img);
      };
    },
    download_gafete: function(){
      console.log('Bandera Acceso sin Codigo = ', this.bandAccessNoCode)
      this.loading_gafete = true
      console.log('Datos de la Invitación: ')
      console.log(this.info_invitation)
      // console.log(this.info_invitation)
      const toDataUrl = (url, callback) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = () => {
          const reader = new FileReader();
          reader.onloadend = () => {
            callback(reader.result);
          };
          reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
      };
      var pdf = new jsPDF('l', 'in', [288, 144])
      // Black square with rounded corners
      pdf.setDrawColor(0)
      pdf.setFontSize(9)
      pdf.text(this.$t('fecha_hora_acceso'),
          2.3,
          0.4)
      pdf.setLineWidth(0.02)
      pdf.line(2.3, 0.42, 3.7, 0.42)
      pdf.setFontStyle("normal")
      pdf.text(this.getCurrentDateSlash() + ' ' + this.getCurrentTime(), 2.7, 0.6)
      pdf.setFontSize(14)
      // pdf.setFillColor(255, 255, 255)
      // pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
      // pdf.setFontStyle("bold")
      // pdf.text(this.info_invitation.empresa,
      //     this.xOffset(pdf, this.info_invitation.empresa),
      //     130)
      pdf.line(this.xOffset(pdf, this.$t('Visitante').toUpperCase()), 0.92, 2.6, 0.92)
      pdf.setFontStyle("bold")
      pdf.text(this.$t('Visitante').toUpperCase(),
          this.xOffset(pdf, this.$t('Visitante').toUpperCase()),
          0.9)
      pdf.setFontSize(16)
      pdf.setFontStyle("normal")
      pdf.text(this.bandAccessNoCode === true ? this.dataAccessNoCode.nombre : this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName,
          this.xOffset(pdf, this.bandAccessNoCode === true ? this.dataAccessNoCode.nombre : this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName),
          1.2)
      pdf.line(this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()), 1.47, 2.6, 1.47)
      pdf.setFontSize(14)
      pdf.setFontStyle("bold")
      pdf.text(this.$t('Anfitrion').toUpperCase(),
          this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()),
          1.45)
      pdf.setFontSize(16)
      pdf.setFontStyle("normal")
      pdf.text(this.bandAccessNoCode === true ? this.dataAccessNoCode.host : this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName,
          this.xOffset(pdf, this.bandAccessNoCode === true ? this.dataAccessNoCode.host : this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName),
          1.70)
      // pdf.setFontStyle("normal")
      // pdf.text(this.$t('Area'),
      //     this.xOffset(pdf, this.$t('Area')),
      //     205)
      // pdf.setTextColor(this.info_invitation.areaColor)
      // pdf.setFontStyle("bold")
      // pdf.text(this.info_invitation.areaName.toUpperCase(),
      //     this.xOffset(pdf, this.info_invitation.areaName.toUpperCase()),
      //     220)
      pdf.setTextColor('#000000')
      // pdf.setLineWidth(4.0)
      // pdf.setDrawColor(this.info_invitation.areaColor)
      // pdf.setFillColor('#FFFFFF')
      // pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
      // console.log(myBase64); // myBase64 is the base64 string
      // pdf.addImage(myBase64, 'WEBP', 215, 260, 180, 180);
      toDataUrl(this.bandAccessNoCode === true ? this.dataAccessNoCode.company_logo : this.info_invitation.logoEmpresa, (logo_guest) => {
        pdf.addImage(logo_guest, 'WEBP', 0.25, 0.25, 0.9, 0.7);
        pdf.save('gafete.pdf')
        this.loading_gafete = false
        this.band_current_time = false
      });
    },
    showOptions() {
      this.reasons = null
      this.dialogReasons = true
    },
    chooseReason () {
      console.log('Reason Choosen = ', this.reasons)
      this.loading_reason = true
      console.log(this.qr_code)
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/empresas/access/create_deny_access',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_invitacion: this.info_invitation.id,
          qr_code: this.qr_code,
          comentarios_VE: this.reasons,
          estado: 2
        }
      }
      axios(config)
          .then(response => {
            this.loading_reason = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('msg_host_notified_correctly'))
            this.dialogReasons = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading_reason = false
          })
    },
    getCurrentDateSlash () {
      var today = new Date()
      var aux = ''
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      aux = dd + '-' + mm + '-' + yyyy
      return aux
    },
    getCurrentTime () {
      var today = new Date()
      var aux = ''
      var hh = today.getHours()
      var mm = today.getMinutes()

      if (hh < 10) {
        hh = '0' + hh
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      aux = hh + ':' + mm
      return aux
    },
    send () {
      this.loading = true
      const config = {
        method: 'PATCH',
        url: 'https://empresa-service.intrare.app/empresas/health_survey/answered/' + this.idUserByInvitation,
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios(config)
          .then(ok => {
            this.loading = false
            this.dialogShowSurvey = false
            this.dialog_errores = false
            this.survey = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('survey_success'))
            if(this.a_qr_code.length > 10)
              this.qr_code = this.a_qr_code
            setTimeout(this.clear2, 3000)
            this.get_invitation()
          })
          .catch(() => {
            this.loading = false
          })
    }
  }
}
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}

#datas {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#datas td, #datas th {
  padding: 8px;
}

#datas tr:nth-child(even){background-color: #f2f2f2;}

#datas tr:hover {background-color: #ddd;}

#datas th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #002b48;
  color: white;
}
.edge {
  border-radius: 8px;
  border-color: #002b48 #002b48 #002b48 #002b48;
  border-width: 3px 3px 3px 3px;
  border-style: solid solid solid solid;
}
</style>